import React from 'react';
import ReactDOM from 'react-dom';
import './style.css';
import Chart from 'chart.js';
/*************************************************************
* Types of Activities
* The below section defines the types of activities that
* can be selected. Each activity is then sorted into lists
* based on the category they fall under.
* Calculates for hour totals are included with each type of
* activity for simpler context. 
**************************************************************/

// Modules for Writing Activities
class DiscussionActivity extends React.Component {
	constructor(props){
		super(props);
		const activityInfo = this.props.actInfo;
		const numPostsVal = (Object.prototype.hasOwnProperty.call(activityInfo, 'numPosts') ? activityInfo.numPosts : 0);
		const respondVal = (Object.prototype.hasOwnProperty.call(activityInfo, 'respond') ? activityInfo.respond : false);
		this.state = {
			visible: activityInfo.visible,
			category: activityInfo.category,
			type: activityInfo.type,
			actID: activityInfo.actID,
			eia: activityInfo.eia,
			ela: activityInfo.ela,
			numPosts: numPostsVal,
			respond: respondVal
		};
		this.props.saveAct(this.state);
		this.handleInputChange = this.handleInputChange.bind(this);
		this.delete = this.delete.bind(this);
	}

	delete(){
		this.setState({
			visible: false
		});
		this.props.deleteAct(this.state.actID);
	}

	handleInputChange(event){
		const boxName = event.target.name;
		const value = event.target.name === 'discussion_responses' ? event.target.checked : event.target.value;
		var numPosts = !(this.state.numPosts) ? 0 : parseFloat(this.state.numPosts);
		var respond = this.state.respond;
		var currVal = 0;
		var newELA = 0;
		var newEIA = 0;
		const updatedState = {};
		Object.assign(updatedState, this.state);

		switch(boxName) {
			case "discussion_num":
				if(value !== ''){ currVal = parseFloat(value); }
				numPosts = currVal;
				this.setState({numPosts: value});
				updatedState.numPosts = value;
				break;
			case "discussion_responses":
				respond = value;
				updatedState.respond = value;
				break;
			default: break;
		}
		
		if(respond) { newEIA = numPosts; }
		else { newEIA = numPosts * .5;}
		newELA = numPosts;
		this.setState({
			eia: newEIA,
			ela: newELA,
			respond: respond
		});

		updatedState.eia = newEIA;
		updatedState.ela = newELA;
		this.props.calcTotals(updatedState, this.state.actID, this.state.category, newEIA, newELA);
	}

	render() {
		if(!this.state.visible) return null;
		return (
		<li key={this.state.actID} className="activity">
			<h3>{this.props.actInfo.name}</h3>
			<button className="delete" onClick={this.delete}>
				<svg aria-hidden="true" className="svg_delete" viewBox="0 0 20 20"><path></path></svg>
				Delete this activity
			</button>
            <p>{this.props.actInfo.description}</p>
            <form>
	            <label>
	            <div className="text">Number of Discussions:</div> 
	            <input
	            	name="discussion_num"
	            	type="number" min="0"
	            	value={this.state.numPosts}
	            	onChange={this.handleInputChange}
	            />
	            </label>
	            <br />
	            <label>
	            <div className="checkbox">Reading and Responding to Others Required:</div>
	            <input
	            	name="discussion_responses"
	            	type="checkbox"
	            	checked={this.state.respond}
	            	onChange={this.handleInputChange}
	            />
	           	</label>
           	</form>	
		</li>
		);
	}
}
class ReflectionPaperActivity extends React.Component {
	constructor(props){
		super(props);
		const activityInfo = this.props.actInfo;
		const numPapersVal = (Object.prototype.hasOwnProperty.call(activityInfo, 'numPapers') ? activityInfo.numPapers : 0);
		const numPagesVal = (Object.prototype.hasOwnProperty.call(activityInfo, 'numPages') ? activityInfo.numPages : 0);
		const sharedVal = (Object.prototype.hasOwnProperty.call(activityInfo, 'shared') ? activityInfo.shared : false);
		this.state = {
			visible: activityInfo.visible,
			category: activityInfo.category,
			type: activityInfo.type,
			actID: activityInfo.actID,
			eia: activityInfo.eia,
			ela: activityInfo.ela,
			numPapers: numPapersVal,
			numPages: numPagesVal,
			shared: sharedVal
		};
		this.props.saveAct(this.state);
		this.handleInputChange = this.handleInputChange.bind(this);
		this.delete = this.delete.bind(this);
	}

	delete(){
		this.setState({
			visible: false
		});
		this.props.deleteAct(this.state.actID);
	}

	handleInputChange(event){
		const boxName = event.target.name;
		const value = event.target.name === 'reflection_shared' ? event.target.checked : event.target.value;
		var numPapers = !(this.state.numPapers) ? 0 : parseFloat(this.state.numPapers);
		var numPages = !(this.state.numPages) ? 0 : parseFloat(this.state.numPages);
		var shared = this.state.shared;
		var currVal = 0;
		var newELA = 0;
		var newEIA = 0;
		const updatedState = {};
		Object.assign(updatedState, this.state);

		switch(boxName) {
			case "reflection_num":
				if(value !== ''){ currVal = parseFloat(value); }
				numPapers = currVal;
				this.setState({numPapers: value});
				updatedState.numPapers = value;
				break;
			case "reflection_pgs":
				if(value !== ''){ currVal = parseFloat(value); }
				numPages = currVal;
				this.setState({numPages: value});
				updatedState.numPages = value;
				break;
			case "reflection_shared":
				shared = value;
				updatedState.shared = value;
				break;
			default: break;
		}

		if(shared) { newEIA = numPapers; }
		else { newEIA = numPapers * .5;}
		newELA = numPapers * numPages * .5;
		this.setState({
			eia: newEIA,
			ela: newELA,
			shared: shared
		});

		updatedState.eia = newEIA;
		updatedState.ela = newELA;
		this.props.calcTotals(updatedState, this.state.actID, this.state.category, newEIA, newELA);
	}

	render() {
		if(!this.state.visible) return null;
		return (
		<li key={this.state.actID} className="activity">
			<h3>{this.props.actInfo.name}</h3>
			<button className="delete" onClick={this.delete}>
				<svg aria-hidden="true" className="svg_delete" viewBox="0 0 20 20"><path></path></svg>
				Delete this activity
			</button>
            <p>{this.props.actInfo.description}</p>
            <form>
	            <label>
	            <div className="text">Number of Papers:</div> 
	            <input
	            	name="reflection_num"
	            	type="number" min="0"
	            	value={this.state.numPapers}
	            	onChange={this.handleInputChange}
	            />
	            </label>
	            <br />
	            <label>
	            <div className="text">Number of Pages:</div> 
	            <input
	            	name="reflection_pgs"
	            	type="number" min="0"
	            	value={this.state.numPages}
	            	onChange={this.handleInputChange}
	            />
	            </label>
	            <br />
	            <label>
	            <div className="checkbox">Students required to read other papers:</div> 
	            <input
	            	name="reflection_shared"
	            	type="checkbox"
	            	checked={this.state.shared}
	            	onChange={this.handleInputChange}
	            />
	            </label>
            </form>
		</li>
		);
	}
} 
class ResearchPaperActivity extends React.Component {
	constructor(props){
		super(props);
		const activityInfo = this.props.actInfo;
		const numPapersVal = (Object.prototype.hasOwnProperty.call(activityInfo, 'numPapers') ? activityInfo.numPapers : 0);
		const numPagesVal = (Object.prototype.hasOwnProperty.call(activityInfo, 'numPages') ? activityInfo.numPages : 0);
		this.state = {
			visible: activityInfo.visible,
			category: activityInfo.category,
			type: activityInfo.type,
			actID: activityInfo.actID,
			eia: activityInfo.eia,
			ela: activityInfo.ela,
			numPapers: numPapersVal,
			numPages: numPagesVal,
		};
		this.props.saveAct(this.state);
		this.handleInputChange = this.handleInputChange.bind(this);
		this.delete = this.delete.bind(this);
	}

	delete(){
		this.setState({
			visible: false
		});
		this.props.deleteAct(this.state.actID);
	}

	handleInputChange(event){
		const boxName = event.target.name;
		const value = event.target.value;
		var numPapers = !(this.state.numPapers) ? 0 : parseFloat(this.state.numPapers);
		var numPages = !(this.state.numPages) ? 0 : parseFloat(this.state.numPages);
		var currVal = 0;
		var newELA = 0;
		var newEIA = 0;
		const updatedState = {};
		Object.assign(updatedState, this.state);

		switch(boxName) {
			case "research_num":
				if(value !== ''){ currVal = parseFloat(value); }
				numPapers = currVal;
				this.setState({numPapers: value});
				updatedState.numPapers = value;
				break;
			case "research_pgs":
				if(value !== ''){ currVal = parseFloat(value); }
				numPages = currVal;
				this.setState({numPages: value});
				updatedState.numPages = value;
				break;
			default: break;
		}

		newEIA = numPapers;
		newELA = numPapers * numPages * 2;
		this.setState({
			eia: newEIA,
			ela: newELA,
		});

		updatedState.eia = newEIA;
		updatedState.ela = newELA;
		this.props.calcTotals(updatedState, this.state.actID, this.state.category, newEIA, newELA);
	}

	render() {
		if(!this.state.visible) return null;
		return (
		<li key={this.state.actID} className="activity">
			<h3>{this.props.actInfo.name}</h3>
			<button className="delete" onClick={this.delete}>
				<svg aria-hidden="true" className="svg_delete" viewBox="0 0 20 20"><path></path></svg>
				Delete this activity
			</button>
            <p>{this.props.actInfo.description}</p>
            <form>
	            <label>
	            <div className="text">Number of Papers:</div> 
	            <input
	            	name="research_num"
	            	type="number" min="0"
	            	value={this.state.numPapers}
	            	onChange={this.handleInputChange}
	            />
	            </label>
	            <br />
	            <label>
	            <div className="text">Number of Pages:</div> 
	            <input
	            	name="research_pgs"
	            	type="number" min="0"
	            	value={this.state.numPages}
	            	onChange={this.handleInputChange}
	            />
	            </label>
            </form>
		</li>
		);
	}
}
class PeerReviewActivity extends React.Component {
	constructor(props){
		super(props);
		const activityInfo = this.props.actInfo;
		const numReviewsVal = (Object.prototype.hasOwnProperty.call(activityInfo, 'numReviews') ? activityInfo.numReviews : 0);
		const numPagesVal = (Object.prototype.hasOwnProperty.call(activityInfo, 'numPages') ? activityInfo.numPages : 0);
		this.state = {
			visible: activityInfo.visible,
			category: activityInfo.category,
			type: activityInfo.type,
			actID: activityInfo.actID,
			eia: activityInfo.eia,
			ela: activityInfo.ela,
			numReviews: numReviewsVal,
			numPages: numPagesVal,
		};
		this.props.saveAct(this.state);
		this.handleInputChange = this.handleInputChange.bind(this);
		this.delete = this.delete.bind(this);
	}

	delete(){
		this.setState({
			visible: false
		});
		this.props.deleteAct(this.state.actID);
	}

	handleInputChange(event){
		const boxName = event.target.name;
		const value = event.target.value;
		var numReviews = !(this.state.numReviews) ? 0 : parseFloat(this.state.numReviews);
		var numPages = !(this.state.numPages) ? 0 : parseFloat(this.state.numPages);
		var currVal = 0;
		var newEIA = 0;
		var newELA = 0;
		const updatedState = {};
		Object.assign(updatedState, this.state);

		if(value !== ''){ currVal = parseFloat(value); }
		switch(boxName) {
			case "review_num":
				numReviews = currVal;
				this.setState({numReviews: value});
				updatedState.numReviews = value;
				break;
			case "review_pgs":
				numPages = currVal;
				this.setState({numPages: value});
				updatedState.numPages = value;
				break;
			default: break;
		}

		newEIA = numReviews * numPages;
		newELA = numReviews * .5;
		this.setState({
			eia: newEIA,
			ela: newELA
		});

		updatedState.eia = newEIA;
		updatedState.ela = newELA;
		this.props.calcTotals(updatedState, this.state.actID, this.state.category, newEIA, newELA);
	}

	render() {
		if(!this.state.visible) return null;
		return (
		<li key={this.state.actID} className="activity">
			<h3>{this.props.actInfo.name}</h3>
			<button className="delete" onClick={this.delete}>
				<svg aria-hidden="true" className="svg_delete" viewBox="0 0 20 20"><path></path></svg>
				Delete this activity
			</button>
            <p>{this.props.actInfo.description}</p>
            <form>
	            <label>
	            <div className="text">Number of Reviews:</div> 
	            <input
	            	name="review_num"
	            	type="number" min="0"
	            	value={this.state.numReviews}
	            	onChange={this.handleInputChange}
	            />
	            </label>
	            <br />
	            <label>
	            <div className="text">Number of Pages Per Review:</div> 
	            <input
	            	name="review_pgs"
	            	type="number" min="0"
	            	value={this.state.numPages}
	            	onChange={this.handleInputChange}
	            />
	            </label>
            </form>
		</li>
		);
	}
}
class BlogActivity extends React.Component {
	constructor(props){
		super(props);
		const activityInfo = this.props.actInfo;
		const numPostsVal = (Object.prototype.hasOwnProperty.call(activityInfo, 'numPosts') ? activityInfo.numPosts : 0);
		const numPagesVal = (Object.prototype.hasOwnProperty.call(activityInfo, 'numPages') ? activityInfo.numPages : 0);
		this.state = {
			visible: activityInfo.visible,
			category: activityInfo.category,
			type: activityInfo.type,
			actID: activityInfo.actID,
			eia: activityInfo.eia,
			ela: activityInfo.ela,
			numPosts: numPostsVal,
			numPages: numPagesVal
		};
		this.props.saveAct(this.state);
		this.handleInputChange = this.handleInputChange.bind(this);
		this.delete = this.delete.bind(this);
	}

	delete(){
		this.setState({visible: false});
		this.props.deleteAct(this.state.actID);
	}

	handleInputChange(event){
		const boxName = event.target.name;
		const value = event.target.value;
		var numPosts = !(this.state.numPosts) ? 0 : this.state.numPosts;
		var numPages = !(this.state.numPages) ? 0 : this.state.numPages;
		var currVal = 0;
		var newELA = 0;
		var newEIA = 0;
		const updatedState = {};
		Object.assign(updatedState, this.state);

		if(value !== ''){ currVal = value; }
		switch(boxName){
			case "blog_posts":
				numPosts = currVal;
				this.setState({numPosts: value});
				updatedState.numPosts = value;
				break;
			case "blog_pgs":
				numPages = currVal;
				this.setState({numPages: value});
				updatedState.numPages = value;
				break;
			default: break;
		}

		newEIA = numPages * numPosts * .5;
		newELA = numPosts * .5;
		this.setState({
			eia: newEIA,
			ela: newELA
		});

		updatedState.eia = newEIA;
		updatedState.ela = newELA;
		this.props.calcTotals(updatedState, this.state.actID, this.state.category, newEIA, newELA);
	}

	render() {
		if(!this.state.visible) return null;
		return (
		<li key={this.state.actID} className="activity">
			<h3>{this.props.actInfo.name}</h3>
			<button className="delete" onClick={this.delete}>
				<svg aria-hidden="true" className="svg_delete" viewBox="0 0 20 20"><path></path></svg>
				Delete this activity
			</button>
            <p>{this.props.actInfo.description}</p>
            <form>
	            <label>
	            <div className="text">Number of Posts:</div>
	            <input
	            	name="blog_posts"
	            	type="number" min="0"
	            	value={this.state.numPosts}
	            	onChange={this.handleInputChange}
	            />
	            </label>
	            <br />
	            <label>
	            <div className="text">Pages per Post:</div>
	            <input
	            	name="blog_pgs"
	            	type="number" min="0"
	            	value={this.state.numPages}
	            	onChange={this.handleInputChange}
	            />
	            </label>
            </form>
		</li>
		);
	}
}
class JournalActivity extends React.Component {
	constructor(props){
		super(props);
		const activityInfo = this.props.actInfo;
		const numPostsVal = (Object.prototype.hasOwnProperty.call(activityInfo, 'numPosts') ? activityInfo.numPosts : 0);
		const numPagesVal = (Object.prototype.hasOwnProperty.call(activityInfo, 'numPages') ? activityInfo.numPages : 0);
		this.state = {
			visible: activityInfo.visible,
			category: activityInfo.category,
			type: activityInfo.type,
			actID: activityInfo.actID,
			eia: activityInfo.eia,
			ela: activityInfo.ela,
			numPosts: numPostsVal,
			numPages: numPagesVal
		};
		this.props.saveAct(this.state);
		this.handleInputChange = this.handleInputChange.bind(this);
		this.delete = this.delete.bind(this);
	}

	delete(){
		this.setState({
			visible: false
		});
		this.props.deleteAct(this.state.actID);
	}

	handleInputChange(event){
		const boxName = event.target.name;
		const value = event.target.value;
		var numPosts = !(this.state.numPosts) ? 0 : this.state.numPosts;
		var numPages = !(this.state.numPages) ? 0 : this.state.numPages;
		var currVal = 0;
		var newELA = 0;
		var newEIA = 0;
		const updatedState = {};
		Object.assign(updatedState, this.state);

		if(value !== ''){ currVal = value; }
		switch(boxName){
			case "journal_posts":
				numPosts = currVal;
				this.setState({numPosts: value});
				updatedState.numPosts = value;
				break;
			case "journal_pgs":
				numPages = currVal;
				this.setState({numPages: value});
				updatedState.numPages = value;
				break;
			default: break;
		}

		newEIA = numPages * numPosts * .5;
		newELA = numPosts * .5;
		this.setState({
			eia: newEIA,
			ela: newELA
		});

		updatedState.eia = newEIA;
		updatedState.ela = newELA;
		this.props.calcTotals(updatedState, this.state.actID, this.state.category, newEIA, newELA);
	}

	render() {
		if(!this.state.visible) return null;
		return (
		<li key={this.state.actID} className="activity">
			<h3>{this.props.actInfo.name}</h3>
			<button className="delete" onClick={this.delete}>
				<svg aria-hidden="true" className="svg_delete" viewBox="0 0 20 20"><path></path></svg>
				Delete this activity
			</button>
            <p>{this.props.actInfo.description}</p>
            <form>
	            <label>
	            <div className="text">Number of Entries:</div> 
	            <input
	            	name="journal_posts"
	            	type="number" min="0"
	            	value={this.state.numPosts}
	            	onChange={this.handleInputChange}
	            />
	            </label>
	            <br />
	            <label>
	            <div className="text">Pages per Entry:</div> 
	            <input
	            	name="journal_pgs"
	            	type="number" min="0"
	            	value={this.state.numPages}
	            	onChange={this.handleInputChange}
	            />
	            </label>
            </form>
		</li>
		);
	}
}
class CaseStudiesActivity extends React.Component {
	constructor(props){
		super(props);
		const activityInfo = this.props.actInfo;
		const numStudiesVal = (Object.prototype.hasOwnProperty.call(activityInfo, 'numStudies') ? activityInfo.numStudies : 0);
		const numPagesVal = (Object.prototype.hasOwnProperty.call(activityInfo, 'numPages') ? activityInfo.numPages : 0);
		this.state = {
			visible: activityInfo.visible,
			category: activityInfo.category,
			type: activityInfo.type,
			actID: activityInfo.actID,
			eia: activityInfo.eia,
			ela: activityInfo.ela,
			numStudies: numStudiesVal,
			numPages: numPagesVal
		};
		this.props.saveAct(this.state);
		this.handleInputChange = this.handleInputChange.bind(this);
		this.delete = this.delete.bind(this);
	}

	delete(){
		this.setState({
			visible: false
		});
		this.props.deleteAct(this.state.actID);
	}

	handleInputChange(event){
		const boxName = event.target.name;
		const value = event.target.value;
		var numStudies = !(this.state.numStudies) ? 0 : parseFloat(this.state.numStudies);
		var numPages = !(this.state.numPages) ? 0 : parseFloat(this.state.numPages);
		var currVal = 0;
		var newELA = 0;
		var newEIA = 0;
		const updatedState = {};
		Object.assign(updatedState, this.state);

		switch(boxName) {
			case "casestudy_num":
				if(value !== ''){ currVal = parseFloat(value); }
				numStudies = currVal;
				this.setState({numStudies: value});
				updatedState.numStudies = value;
				break;
			case "casestudy_pgs":
				if(value !== ''){ currVal = parseFloat(value); }
				numPages = currVal;
				this.setState({numPages: value});
				updatedState.numPages = value;
				break;
			default: break;
		}

		newEIA = numStudies;
		newELA = numStudies * numPages * 2;
		this.setState({
			eia: newEIA,
			ela: newELA,
		});

		updatedState.eia = newEIA;
		updatedState.ela = newELA;
		this.props.calcTotals(updatedState, this.state.actID, this.state.category, newEIA, newELA);
	}

	render() {
		if(!this.state.visible) return null;
		return (
		<li key={this.state.actID} className="activity">
			<h3>{this.props.actInfo.name}</h3>
			<button className="delete" onClick={this.delete}>
				<svg aria-hidden="true" className="svg_delete" viewBox="0 0 20 20"><path></path></svg>
				Delete this activity
			</button>
            <p>{this.props.actInfo.description}</p>
            <form>
	            <label>
	            <div className="text">Number of Studies:</div> 
	            <input
	            	name="casestudy_num"
	            	type="number" min="0"
	            	value={this.state.numStudies}
	            	onChange={this.handleInputChange}
	            />
	            </label>
	            <br />
	            <label>
	            <div className="text">Pages Per Analysis:</div> 
	            <input
	            	name="casestudy_pgs"
	            	type="number" min="0"
	            	value={this.state.numPages}
	            	onChange={this.handleInputChange}
	            />
	            </label>
            </form>
		</li>
		);
	}
}
class PostingUpdatesActivity extends React.Component {
	constructor(props){
		super(props);
		const activityInfo = this.props.actInfo;
		const numPostsVal = (Object.prototype.hasOwnProperty.call(activityInfo, 'numPosts') ? activityInfo.numPosts : 0);
		this.state = {
			visible: activityInfo.visible,
			category: activityInfo.category,
			type: activityInfo.type,
			actID: activityInfo.actID,
			eia: activityInfo.eia,
			ela: activityInfo.ela,
			numPosts: numPostsVal,
		};
		this.props.saveAct(this.state);
		this.handleInputChange = this.handleInputChange.bind(this);
		this.delete = this.delete.bind(this);
	}

	delete(){
		this.setState({
			visible: false
		});
		this.props.deleteAct(this.state.actID);
	}

	handleInputChange(event){
		const value = event.target.value;
		var newELA = 0;
		var newEIA = 0;
		const updatedState = {};
		Object.assign(updatedState, this.state);

		if(value !== ''){newELA = parseFloat(value);}
		else {newELA = 0;}

		this.setState({
			ela: newELA,
			numPosts: value
		});

		updatedState.eia = newEIA;
		updatedState.ela = newELA;
		updatedState.numPosts = value;
		this.props.calcTotals(updatedState, this.state.actID, this.state.category, newEIA, newELA);
	}

	render() {
		if(!this.state.visible) return null;
		return (
		<li key={this.state.actID} className="activity">
			<h3>{this.props.actInfo.name}</h3>
			<button className="delete" onClick={this.delete}>
				<svg aria-hidden="true" className="svg_delete" viewBox="0 0 20 20"><path></path></svg>
				Delete this activity
			</button>
            <p>{this.props.actInfo.description}</p>
            <form>
	            <label>
	            <div className="text">Number of Posts:</div> 
	            <input
	            	name="update_num"
	            	type="number" min="0"
	            	value={this.state.numPosts}
	            	onChange={this.handleInputChange}
	            />
	            </label>
	        </form>
		</li>
		);
	}
}

// Modules for Reading & Watching Activities
class AssignedReadingActivity extends React.Component {
	constructor(props){
		super(props);
		const activityInfo = this.props.actInfo;
		const numPagesVal = (Object.prototype.hasOwnProperty.call(activityInfo, 'numPages') ? activityInfo.numPages : 0);
		this.state = {
			visible: activityInfo.visible,
			category: activityInfo.category,
			type: activityInfo.type,
			actID: activityInfo.actID,
			eia: activityInfo.eia,
			ela: activityInfo.ela,
			numPages: numPagesVal
		};
		this.props.saveAct(this.state);
		this.handleInputChange = this.handleInputChange.bind(this);
		this.delete = this.delete.bind(this);
	}

	delete(){
		this.setState({
			visible: false
		});
		this.props.deleteAct(this.state.actID);
	}

	handleInputChange(event){
		const boxName = event.target.name;
		const value = event.target.value;
		var numPages = !(this.state.numPages) ? 0 : parseFloat(this.state.numPages);
		var currVal = 0;
		var newELA = 0;
		const updatedState = {};
		Object.assign(updatedState, this.state);

		switch(boxName) {
			case "reading_pgs":
				if(value !== ''){ currVal = parseFloat(value); }
				numPages = currVal;
				this.setState({numPages: value});
				updatedState.numPages = value;
				break;
			default: break;
		}

		newELA = numPages * (3/60);
		this.setState({
			ela: newELA,
		});

		updatedState.eia = this.state.eia;
		updatedState.ela = newELA;
		this.props.calcTotals(updatedState, this.state.actID, this.state.category, this.state.eia, newELA);
	}

	render() {
		if(!this.state.visible) return null;
		return (
		<li key={this.state.actID} className="activity">
			<h3>{this.props.actInfo.name}</h3>
			<button className="delete" onClick={this.delete}>
				<svg aria-hidden="true" className="svg_delete" viewBox="0 0 20 20"><path></path></svg>
				Delete this activity
			</button>
            <p>{this.props.actInfo.description}</p>
            <form>
	            <label>
	            <div className="text">Number of Pages:</div> 
	            <input
	            	name="reading_pgs"
	            	type="number" min="0"
	            	value={this.state.numPages}
	            	onChange={this.handleInputChange}
	            />
	            </label>
            </form>
		</li>
		);
	}
}
class ScholarlyReadingActivity extends React.Component {
	constructor(props){
		super(props);
		const activityInfo = this.props.actInfo;
		const numPagesVal = (Object.prototype.hasOwnProperty.call(activityInfo, 'numPages') ? activityInfo.numPages : 0);
		this.state = {
			visible: activityInfo.visible,
			category: activityInfo.category,
			type: activityInfo.type,
			actID: activityInfo.actID,
			eia: activityInfo.eia,
			ela: activityInfo.ela,
			numPages: numPagesVal
		};
		this.props.saveAct(this.state);
		this.handleInputChange = this.handleInputChange.bind(this);
		this.delete = this.delete.bind(this);
	}

	delete(){
		this.setState({
			visible: false
		});
		this.props.deleteAct(this.state.actID);
	}

	handleInputChange(event){
		const boxName = event.target.name;
		const value = event.target.value;
		var numPages = !(this.state.numPages) ? 0 : parseFloat(this.state.numPages);
		var currVal = 0;
		var newELA = 0;
		const updatedState = {};
		Object.assign(updatedState, this.state);

		switch(boxName) {
			case "reading_pgs":
				if(value !== ''){ currVal = parseFloat(value); }
				numPages = currVal;
				this.setState({numPages: value});
				updatedState.numPages = value;
				break;
			default: break;
		}

		newELA = numPages * (5/60);
		this.setState({
			ela: newELA,
		});

		updatedState.eia = this.state.eia;
		updatedState.ela = newELA;
		this.props.calcTotals(updatedState, this.state.actID, this.state.category, this.state.eia, newELA);
	}

	render() {
		if(!this.state.visible) return null;
		return (
		<li key={this.state.actID} className="activity">
			<h3>{this.props.actInfo.name}</h3>
			<button className="delete" onClick={this.delete}>
				<svg aria-hidden="true" className="svg_delete" viewBox="0 0 20 20"><path></path></svg>
				Delete this activity
			</button>
            <p>{this.props.actInfo.description}</p>
            <form>
	            <label>
	            <div className="text">Number of Pages:</div> 
	            <input
	            	name="reading_pgs"
	            	type="number" min="0"
	            	value={this.state.numPages}
	            	onChange={this.handleInputChange}
	            />
	            </label>
            </form>
		</li>
		);
	}
}
class LectureActivity extends React.Component {
	constructor(props){
		super(props);
		const activityInfo = this.props.actInfo;
		const numLecturesVal = (Object.prototype.hasOwnProperty.call(activityInfo, 'numPages') ? activityInfo.numLectures : 0);
		const numMinsVal = (Object.prototype.hasOwnProperty.call(activityInfo, 'numMins') ? activityInfo.numMins : 0);
		const numPagesVal = (Object.prototype.hasOwnProperty.call(activityInfo, 'numPages') ? activityInfo.numPages : 0);
		this.state = {
			visible: activityInfo.visible,
			category: activityInfo.category,
			type: activityInfo.type,
			actID: activityInfo.actID,
			eia: activityInfo.eia,
			ela: activityInfo.ela,
			numLectures: numLecturesVal,
			numMins: numMinsVal,
			numPages: numPagesVal
		};
		this.props.saveAct(this.state);
		this.handleInputChange = this.handleInputChange.bind(this);
		this.delete = this.delete.bind(this);
	}

	delete(){
		this.setState({
			visible: false
		});
		this.props.deleteAct(this.state.actID);
	}

	handleInputChange(event){
		const boxName = event.target.name;
		const value = event.target.value;
		var numLectures = !(this.state.numLectures) ? 0 : parseFloat(this.state.numLectures);
		var numMins = !(this.state.numMins) ? 0 : parseFloat(this.state.numMins);
		var numPages = !(this.state.numPages) ? 0 : parseFloat(this.state.numPages);
		var currVal = 0;
		var newEIA = 0;
		var newELA = 0;
		const updatedState = {};
		Object.assign(updatedState, this.state);

		switch(boxName) {
			case "lecture_num":
				if(value !== ''){ currVal = parseFloat(value); }
				numLectures = currVal;
				this.setState({numLectures: value});
				updatedState.numLectures = value;
				break;
			case "lecture_time":
				if(value !== ''){ currVal = parseFloat(value); }
				numMins = currVal;
				this.setState({numMins: value});
				updatedState.numMins = value;
				break;
			case "lecture_pages":
				if(value !== ''){ currVal = parseFloat(value); }
				numPages = currVal;
				this.setState({numPages: value});
				updatedState.numPages = value;
				break;
			default: break;
		}

		newEIA = numLectures * (numMins/60);
		newELA = numLectures * (numPages * .5); 
		this.setState({
			ela: newELA,
			eia: newEIA
		});
		updatedState.eia = newEIA;
		updatedState.ela = newELA;

		this.props.calcTotals(updatedState, this.state.actID, this.state.category, newEIA, newELA);
	}

	render() {
		if(!this.state.visible) return null;
		return (
		<li key={this.state.actID} className="activity">
			<h3>{this.props.actInfo.name}</h3>
			<button className="delete" onClick={this.delete}>
				<svg aria-hidden="true" className="svg_delete" viewBox="0 0 20 20"><path></path></svg>
				Delete this activity
			</button>
            <p>{this.props.actInfo.description}</p>
            <form>
	            <label>
	            <div className="text">Number of Lectures:</div> 
	            <input
	            	name="lecture_num"
	            	type="number" min="0"
	            	value={this.state.numLectures}
	            	onChange={this.handleInputChange}
	            />
	            </label>
	            <br />
	            <label>
	           	<div className="text">Length of Video or Lecture (minutes):</div> 
	            <input
	            	name="lecture_time"
	            	type="number" min="0"
	            	value={this.state.numMins}
	            	onChange={this.handleInputChange}
	            />
	            </label>
	            <br />
	            <label>
	            <div className="text">Estimated Number of Pages of Notes:</div> 
	            <input
	            	name="lecture_pages"
	            	type="number" min="0"
	            	value={this.state.numPages}
	            	onChange={this.handleInputChange}
	            />
	            </label>
            </form>
			</li>
		);
	}
}
class InstructionalContentActivity extends React.Component {
	constructor(props){
		super(props);
		const activityInfo = this.props.actInfo;
		const numPostsVal = (Object.prototype.hasOwnProperty.call(activityInfo, 'numPosts') ? activityInfo.numPosts : 0);
		this.state = {
			visible: activityInfo.visible,
			category: activityInfo.category,
			type: activityInfo.type,
			actID: activityInfo.actID,
			eia: activityInfo.eia,
			ela: activityInfo.ela,
			numPosts: numPostsVal
		};
		this.props.saveAct(this.state);
		this.handleInputChange = this.handleInputChange.bind(this);
		this.delete = this.delete.bind(this);
	}

	delete(){
		this.setState({
			visible: false
		});
		this.props.deleteAct(this.state.actID);
	}

	handleInputChange(event){
		const value = event.target.value;
		var newELA = 0;
		var newEIA = 0;
		const updatedState = {};
		Object.assign(updatedState, this.state);

		if(value !== ''){newEIA = parseFloat(value);}
		else {newEIA = 0;}

		this.setState({
			eia: newELA,
			numPosts: value
		});

		updatedState.eia = newEIA;
		updatedState.ela = newELA;
		updatedState.numPosts = value;
		this.props.calcTotals(updatedState, this.state.actID, this.state.category, newEIA, newELA);
	}

	render() {
		if(!this.state.visible) return null;
		return (
		<li key={this.state.actID} className="activity">
			<h3>{this.props.actInfo.name}</h3>
			<button className="delete" onClick={this.delete}>
				<svg aria-hidden="true" className="svg_delete" viewBox="0 0 20 20"><path></path></svg>
				Delete this activity
			</button>
            <p>{this.props.actInfo.description}</p>
            <form>
	            <label>
	            <div className="text">Number of Content Posts:</div> 
	            <input
	            	name="post_num"
	            	type="number" min="0"
	            	value={this.state.numPosts}
	            	onChange={this.handleInputChange}
	            />
	            </label>
            </form>
		</li>
		);
	}
}
class ProblemSolvingActivity extends React.Component {
	constructor(props){
		super(props);
		const activityInfo = this.props.actInfo;
		const numSceneriosVal = (Object.prototype.hasOwnProperty.call(activityInfo, 'numScenerios') ? activityInfo.numScenerios : 0);
		const numPagesVal = (Object.prototype.hasOwnProperty.call(activityInfo, 'numPages') ? activityInfo.numPages : 0);
		this.state = {
			visible: activityInfo.visible,
			category: activityInfo.category,
			type: activityInfo.type,
			actID: activityInfo.actID,
			eia: activityInfo.eia,
			ela: activityInfo.ela,
			numScenerios: numSceneriosVal,
			numPages: numPagesVal
		};
		this.props.saveAct(this.state);
		this.handleInputChange = this.handleInputChange.bind(this);
		this.delete = this.delete.bind(this);
	}

	delete(){
		this.setState({
			visible: false
		});
		this.props.deleteAct(this.state.actID);
	}

	handleInputChange(event){
		const boxName = event.target.name;
		const value = event.target.value;
		var numScenerios = !(this.state.numScenerios) ? 0 : parseFloat(this.state.numScenerios);
		var numPages = !(this.state.numPages) ? 0 : parseFloat(this.state.numPages);
		var currVal = 0;
		var newELA = 0;
		var newEIA = 0;
		const updatedState = {};
		Object.assign(updatedState, this.state);

		switch(boxName) {
			case "probsolve_num":
				if(value !== ''){ currVal = parseFloat(value); }
				numScenerios = currVal;
				this.setState({numScenerios: value});
				updatedState.numScenerios = value;
				break;
			case "probsolve_pgs":
				if(value !== ''){ currVal = parseFloat(value); }
				numPages = currVal;
				this.setState({numPages: value});
				updatedState.numPages = value;
				break;
			default: break;
		}

		newEIA = numScenerios;
		newELA = numScenerios * numPages * 2;
		this.setState({
			eia: newEIA,
			ela: newELA,
		});

		updatedState.eia = newEIA;
		updatedState.ela = newELA;
		this.props.calcTotals(updatedState, this.state.actID, this.state.category, newEIA, newELA);
	}

	render() {
		if(!this.state.visible) return null;
		return (
		<li key={this.state.actID} className="activity">
			<h3>{this.props.actInfo.name}</h3>
			<button className="delete" onClick={this.delete}>
				<svg aria-hidden="true" className="svg_delete" viewBox="0 0 20 20"><path></path></svg>
				Delete this activity
			</button>
            <p>{this.props.actInfo.description}</p>
            <form>
	            <label>
	            <div className="text">Number of Scenarios:</div> 
	            <input
	            	name="probsolve_num"
	            	type="number" min="0"
	            	value={this.state.numScenerios}
	            	onChange={this.handleInputChange}
	            />
	            </label>
	            <br />
	            <label>
	            <div className="text">Pages Per Scenario:</div> 
	            <input
	            	name="probsolve_pgs"
	            	type="number" min="0"
	            	value={this.state.numPages}
	            	onChange={this.handleInputChange}
	            />
            </label>
            </form>
		</li>
		);
	}
}

// Modules for Communication Activites
class SyncCommunicationActivity extends React.Component {
	constructor(props){
		super(props);
		const activityInfo = this.props.actInfo;
		const numCommVal = (Object.prototype.hasOwnProperty.call(activityInfo, 'numComm') ? activityInfo.numComm : 0);
		const numHoursVal = (Object.prototype.hasOwnProperty.call(activityInfo, 'numHours') ? activityInfo.numHours : 0);
		this.state = {
			visible: activityInfo.visible,
			category: activityInfo.category,
			type: activityInfo.type,
			actID: activityInfo.actID,
			eia: activityInfo.eia,
			ela: activityInfo.ela,
			numComm: numCommVal,
			numHours: numHoursVal
		};
		this.props.saveAct(this.state);
		this.handleInputChange = this.handleInputChange.bind(this);
		this.delete = this.delete.bind(this);
	}

	delete(){
		this.setState({
			visible: false
		});
		this.props.deleteAct(this.state.actID);
	}

	handleInputChange(event){
		const boxName = event.target.name;
		const value = event.target.value;
		var numComm = !(this.state.numComm) ? 0 : parseFloat(this.state.numComm);
		var numHours = !(this.state.numHours) ? 0 : parseFloat(this.state.numHours);
		var currVal = 0;
		var newEIA = 0;
		var newELA = 0;
		const updatedState = {};
		Object.assign(updatedState, this.state);

		if(value !== ''){ currVal = parseFloat(value); }
		switch(boxName) {
			case "comm_num":
				numComm = currVal;
				this.setState({numComm: value});
				updatedState.numComm = value;
				break;
			case "comm_hrs":
				numHours = currVal;
				this.setState({numHours: value});
				updatedState.numHours = value;
				break;
			default: break;
		}

		newEIA = numComm * numHours;
		newELA = numComm * numHours;
		this.setState({
			eia: newEIA,
			ela: newELA
		});

		updatedState.eia = newEIA;
		updatedState.ela = newELA;
		this.props.calcTotals(updatedState, this.state.actID, this.state.category, newEIA, newELA);
	}

	render() {
		if(!this.state.visible) return null;
		return (
		<li key={this.state.actID} className="activity">
			<h3>{this.props.actInfo.name}</h3>
			<button className="delete" onClick={this.delete}>
				<svg aria-hidden="true" className="svg_delete" viewBox="0 0 20 20"><path></path></svg>
				Delete this activity
			</button>
            <p>{this.props.actInfo.description}</p>
            <form>
	            <label>
	            <div className="text">Number of Communications:</div> 
	            <input
	            	name="comm_num"
	            	type="number" min="0"
	            	value={this.state.numComm}
	            	onChange={this.handleInputChange}
	            />
	            </label>
	            <br />
	            <label>
	            <div className="text">Number of Hours Per Communication:</div> 
	            <input
	            	name="comm_hrs"
	            	type="number" min="0"
	            	value={this.state.numHours}
	            	onChange={this.handleInputChange}
	            />
	            </label>
            </form>
		</li>
		);
	}
}

// Modules for Projects and Hands on Learning Activities
class GroupProjectActivity extends React.Component {
	constructor(props){
		super(props);
		const activityInfo = this.props.actInfo;
		const numProjVal = (Object.prototype.hasOwnProperty.call(activityInfo, 'numProj') ? activityInfo.numProj : 0);
		const numWeeksVal = (Object.prototype.hasOwnProperty.call(activityInfo, 'numWeeks') ? activityInfo.numWeeks : 0);
		const sizeProjVal = (Object.prototype.hasOwnProperty.call(activityInfo, 'sizeProj') ? activityInfo.sizeProj : 'small');
		this.state = {
			visible: activityInfo.visible,
			category: activityInfo.category,
			type: activityInfo.type,
			actID: activityInfo.actID,
			eia: activityInfo.eia,
			ela: activityInfo.ela,
			numProj: numProjVal,
			numWeeks: numWeeksVal,
			sizeProj: sizeProjVal
		};
		this.props.saveAct(this.state);
		this.handleInputChange = this.handleInputChange.bind(this);
		this.delete = this.delete.bind(this);
	}

	delete(){
		this.setState({
			visible: false
		});
		this.props.deleteAct(this.state.actID);
	}

	handleInputChange(event){
		const boxName = event.target.name;
		const value = event.target.value;
		var numProj = !(this.state.numProj) ? 0 : parseFloat(this.state.numProj);
		var numWeeks = !(this.state.numWeeks) ? 0 : parseFloat(this.state.numWeeks);
		var sizeProj = this.state.sizeProj;
		var eiaScale = 1;
		var elaScale = 1;
		var newEIA = 0;
		var newELA = 0;
		const updatedState = {};
		Object.assign(updatedState, this.state);

	
		switch(boxName) {
			case "group_num":
				if(value){numProj = parseFloat(value);}
				else {numProj = 0;}
				this.setState({numProj: value});
				updatedState.numProj = value;
				break;
			case "group_weeks":
				if(value){numWeeks = parseFloat(value);}
				else {numWeeks = 0;}
				this.setState({numWeeks: value});
				updatedState.numWeeks = value;
				break;
			case "group_size":
				sizeProj = value;
				this.setState({sizeProj: value});
				updatedState.sizeProj = value;
				break;
			default: break;
		}

		if(sizeProj === "small") {eiaScale = 1; elaScale = 1;}
		else if(sizeProj === "medium") {eiaScale = 2; elaScale = 5;}
		else if(sizeProj === "large") {eiaScale = 3; elaScale = 10;}
		newEIA = numProj * numWeeks * eiaScale;
		newELA = numProj * numWeeks * elaScale;
		this.setState({
			eia: newEIA,
			ela: newELA
		});

		updatedState.eia = newEIA;
		updatedState.ela = newELA;
		this.props.calcTotals(updatedState, this.state.actID, this.state.category, newEIA, newELA);
	}

	render() {
		if(!this.state.visible) return null;
		return (
		<li key={this.state.actID} className="activity">
			<h3>{this.props.actInfo.name}</h3>
			<button className="delete" onClick={this.delete}>
				<svg aria-hidden="true" className="svg_delete" viewBox="0 0 20 20"><path></path></svg>
				Delete this activity
			</button>
            <p>{this.props.actInfo.description}</p>
            <form>
	            <label>
	            <div className="text">Number of Projects:</div>
	            <input
	            	name="group_num"
	            	type="number" min="0"
	            	value={this.state.numProj}
	            	onChange={this.handleInputChange}
	            />
	            </label>
	            <br />
	            <label>
	            <div className="text">Number of Weeks Per Project:</div> 
	            <input
	            	name="group_weeks"
	            	type="number" min="0"
	            	value={this.state.numWeeks}
	            	onChange={this.handleInputChange}
	            />
	            </label>
	            <br />
	            <label>
	            <div className="text">Size of Project:</div> 
	            <select
	            	name="group_size"
	            	value={this.state.sizeProj}
	            	onChange={this.handleInputChange} >
	            	<option value="small">Small</option>
	            	<option value="medium">Medium</option>
	            	<option value="large">Large</option>
	            </select>
	            </label>
            </form>
		</li>
		);
	}
}
class VideoActivity extends React.Component {
	constructor(props){
		super(props);
		const activityInfo = this.props.actInfo;
		const numVideosVal = (Object.prototype.hasOwnProperty.call(activityInfo, 'numVideos') ? activityInfo.numVideos : 0);
		const numMinsVal = (Object.prototype.hasOwnProperty.call(activityInfo, 'numMins') ? activityInfo.numMins : 0);
		this.state = {
			visible: activityInfo.visible,
			category: activityInfo.category,
			type: activityInfo.type,
			actID: activityInfo.actID,
			eia: activityInfo.eia,
			ela: activityInfo.ela,
			numVideos: numVideosVal,
			numMins: numMinsVal
		};
		this.props.saveAct(this.state);
		this.handleInputChange = this.handleInputChange.bind(this);
		this.delete = this.delete.bind(this);
	}

	delete(){
		this.setState({
			visible: false
		});
		this.props.deleteAct(this.state.actID);
	}

	handleInputChange(event){
		const boxName = event.target.name;
		const value = event.target.value;
		var numVideos = !(this.state.numVideos) ? 0 : parseFloat(this.state.numVideos);
		var numMins = !(this.state.numMins) ? 0 : parseFloat(this.state.numMins);
		var newEIA = 0;
		var newELA = 0;
		const updatedState = {};
		Object.assign(updatedState, this.state);

	
		switch(boxName) {
			case "video_num":
				if(value){numVideos = parseFloat(value);}
				else {numVideos = 0;}
				this.setState({numVideos: value});
				updatedState.numVideos = value;
				break;
			case "video_length":
				if(value){numMins = parseFloat(value);}
				else {numMins = 0;}
				this.setState({numMins: value});
				updatedState.numMins = value;
				break;
			default: break;
		}

		// Unclear how to set this
		newEIA = numVideos;
		newELA = numVideos * (numMins/5) * 3;
		this.setState({
			eia: newEIA,
			ela: newELA
		});

		updatedState.eia = newEIA;
		updatedState.ela = newELA;
		this.props.calcTotals(updatedState, this.state.actID, this.state.category, newEIA, newELA);
	}


	render() {
		if(!this.state.visible) return null;
		return (
		<li key={this.state.actID} className="activity">
			<h3>{this.props.actInfo.name}</h3>
			<button className="delete" onClick={this.delete}>
				<svg aria-hidden="true" className="svg_delete" viewBox="0 0 20 20"><path></path></svg>
				Delete this activity
			</button>
            <p>{this.props.actInfo.description}</p>
            <form>
	            <label>
	            <div className="text">Number of Videos:</div> 
	            <input
	            	name="video_num"
	            	type="number" min="0"
	            	value={this.state.numVideos}
	            	onChange={this.handleInputChange}
	            />
	            </label>
	            <br />
	            <label>
	            <div className="text">Length of Video (minutes):</div>
	            <input
	            	name="video_length"
	            	type="number" min="0"
	            	value={this.state.numMins}
	            	onChange={this.handleInputChange}
	            />
            </label>
            </form>
		</li>
		);
	}
}
class PodcastActivity extends React.Component {
	constructor(props){
		super(props);
		const activityInfo = this.props.actInfo;
		const numPodcastsVal = (Object.prototype.hasOwnProperty.call(activityInfo, 'numPodcasts') ? activityInfo.numPodcasts : 0);
		const numMinsVal = (Object.prototype.hasOwnProperty.call(activityInfo, 'numMins') ? activityInfo.numMins : 0);
		this.state = {
			visible: activityInfo.visible,
			category: activityInfo.category,
			type: activityInfo.type,
			actID: activityInfo.actID,
			eia: activityInfo.eia,
			ela: activityInfo.ela,
			numPodcasts: numPodcastsVal,
			numMins: numMinsVal,
		};
		this.props.saveAct(this.state);
		this.handleInputChange = this.handleInputChange.bind(this);
		this.delete = this.delete.bind(this);
	}

	delete(){
		this.setState({
			visible: false
		});
		this.props.deleteAct(this.state.actID);
	}

	handleInputChange(event){
		const boxName = event.target.name;
		const value = event.target.value;
		var numPodcasts = !(this.state.numPodcasts) ? 0 : parseFloat(this.state.numPodcasts);
		var numMins = !(this.state.numMins) ? 0 : parseFloat(this.state.numMins);
		var newEIA = 0;
		var newELA = 0;
		const updatedState = {};
		Object.assign(updatedState, this.state);
	
		switch(boxName) {
			case "podcast_num":
				if(value){numPodcasts = parseFloat(value);}
				else {numPodcasts = 0;}
				this.setState({numPodcasts: value});
				updatedState.numPodcasts = value;
				break;
			case "podcast_length":
				if(value){numMins = parseFloat(value);}
				else {numMins = 0;}
				this.setState({numMins: value});
				updatedState.numMins = value;
				break;
			default: break;
		}

		// Unclear how to set this
		newEIA = numPodcasts;
		newELA = numPodcasts * (numMins/10) * 3;
		this.setState({
			eia: newEIA,
			ela: newELA
		});

		updatedState.eia = newEIA;
		updatedState.ela = newELA;
		this.props.calcTotals(updatedState, this.state.actID, this.state.category, newEIA, newELA);
	}


	render() {
		if(!this.state.visible) return null;
		return (
		<li key={this.state.actID} className="activity">
			<h3>{this.props.actInfo.name}</h3>
			<button className="delete" onClick={this.delete}>
				<svg aria-hidden="true" className="svg_delete" viewBox="0 0 20 20"><path></path></svg>
				Delete this activity
			</button>
            <p>{this.props.actInfo.description}</p>
            <form>
	            <label>
	            <div className="text">Number of Podcasts:</div> 
	            <input
	            	name="podcast_num"
	            	type="number" min="0"
	            	value={this.state.numPodcasts}
	            	onChange={this.handleInputChange}
	            />
	            </label>
	            <br />
	            <label>
	            <div className="text">Length of Podcast (minutes):</div> 
	            <input
	            	name="podcast_length"
	            	type="number" min="0"
	            	value={this.state.numMins}
	            	onChange={this.handleInputChange}
	            />
	            </label>
            </form>
		</li>
		);
	}
}
class MediaAlbumActivity extends React.Component {
	constructor(props){
		super(props);
		const activityInfo = this.props.actInfo;
		const numUploadsVal = (Object.prototype.hasOwnProperty.call(activityInfo, 'numUploads') ? activityInfo.numUploads : 0);
		const numResponsesVal = (Object.prototype.hasOwnProperty.call(activityInfo, 'numResponses') ? activityInfo.numResponses : 0);
		this.state = {
			visible: activityInfo.visible,
			category: activityInfo.category,
			type: activityInfo.type,
			actID: activityInfo.actID,
			eia: activityInfo.eia,
			ela: activityInfo.ela,
			numUploads: numUploadsVal,
			numResponses: numResponsesVal,
		};
		this.props.saveAct(this.state);
		this.handleInputChange = this.handleInputChange.bind(this);
		this.delete = this.delete.bind(this);
	}

	delete(){
		this.setState({
			visible: false
		});
		this.props.deleteAct(this.state.actID);
	}

	handleInputChange(event){
		const boxName = event.target.name;
		const value = event.target.value;
		var numUploads = !(this.state.numUploads) ? 0 : parseFloat(this.state.numUploads);
		var numResponses = !(this.state.numResponses) ? 0 : parseFloat(this.state.numResponses);
		var newEIA = 0;
		var newELA = 0;
		const updatedState = {};
		Object.assign(updatedState, this.state);
	
		switch(boxName) {
			case "upload_num":
				if(value){numUploads = parseFloat(value);}
				else {numUploads = 0;}
				this.setState({numUploads: value});
				updatedState.numUploads = value;
				break;
			case "response_num":
				if(value){numResponses = parseFloat(value);}
				else {numResponses = 0;}
				this.setState({numResponses: value});
				updatedState.numResponses = value;
				break;
			default: break;
		}

		// Unclear how to set this
		newEIA = numUploads * 0.5;
		newELA = numUploads + (numResponses * 0.5);
		this.setState({
			eia: newEIA,
			ela: newELA
		});

		updatedState.eia = newEIA;
		updatedState.ela = newELA;
		this.props.calcTotals(updatedState, this.state.actID, this.state.category, newEIA, newELA);
	}


	render() {
		if(!this.state.visible) return null;
		return (
		<li key={this.state.actID} className="activity">
			<h3>{this.props.actInfo.name}</h3>
			<button className="delete" onClick={this.delete}>
				<svg aria-hidden="true" className="svg_delete" viewBox="0 0 20 20"><path></path></svg>
				Delete this activity
			</button>
            <p>{this.props.actInfo.description}</p>
            <form>
	            <label>
	            <div className="text">Number of Media Uploads:</div> 
	            <input
	            	name="upload_num"
	            	type="number" min="0"
	            	value={this.state.numUploads}
	            	onChange={this.handleInputChange}
	            />
	            </label>
	            <br />
	            <label>
	            <div className="text">Number of Responses to Content:</div> 
	            <input
	            	name="response_num"
	            	type="number" min="0"
	            	value={this.state.numResponses}
	            	onChange={this.handleInputChange}
	            />
	            </label>
            </form>
		</li>
		);
	}
}
class TripActivity extends React.Component {
	constructor(props){
		super(props);
		const activityInfo = this.props.actInfo;
		const numTripsVal = (Object.prototype.hasOwnProperty.call(activityInfo, 'numTrips') ? activityInfo.numTrips : 0);
		const tripTimeVal = (Object.prototype.hasOwnProperty.call(activityInfo, 'tripTime') ? activityInfo.tripTime : 0);
		this.state = {
			visible: activityInfo.visible,
			category: activityInfo.category,
			type: activityInfo.type,
			actID: activityInfo.actID,
			eia: activityInfo.eia,
			ela: activityInfo.ela,
			numTrips: numTripsVal,
			tripTime: tripTimeVal
		};
		this.props.saveAct(this.state);
		this.handleInputChange = this.handleInputChange.bind(this);
		this.delete = this.delete.bind(this);
	}

	delete(){
		this.setState({
			visible: false
		});
		this.props.deleteAct(this.state.actID);
	}

	handleInputChange(event){
		const boxName = event.target.name;
		const value = event.target.value;
		var numTrips = !(this.state.numTrips) ? 0 : parseFloat(this.state.numTrips);
		var tripTime = !(this.state.tripTime) ? 0 : parseFloat(this.state.tripTime);
		var currVal = 0;
		var newEIA = 0;
		var newELA = 0;
		const updatedState = {};
		Object.assign(updatedState, this.state);

		if(value !== ''){ currVal = parseFloat(value); }
		switch(boxName) {
			case "trip_num":
				numTrips = currVal;
				this.setState({numTrips: value});
				updatedState.numTrips = value;
				break;
			case "trip_time":
				tripTime = currVal;
				this.setState({tripTime: value});
				updatedState.tripTime = value;
				break;
			default: break;
		}

		newEIA = numTrips * tripTime;
		newELA = numTrips * tripTime;
		this.setState({
			eia: newEIA,
			ela: newELA
		});

		updatedState.eia = newEIA;
		updatedState.ela = newELA;
		this.props.calcTotals(updatedState, this.state.actID, this.state.category, newEIA, newELA);
	}

	render() {
		if(!this.state.visible) return null;
		return (
		<li key={this.state.actID} className="activity">
			<h3>{this.props.actInfo.name}</h3>
			<button className="delete" onClick={this.delete}>
				<svg aria-hidden="true" className="svg_delete" viewBox="0 0 20 20"><path></path></svg>
				Delete this activity
			</button>
            <p>{this.props.actInfo.description}</p>
            <form>
	            <label>
	            <div className="text">Number of Tours/Trips:</div> 
	            <input
	            	name="trip_num"
	            	type="number" min="0"
	            	value={this.state.numTrips}
	            	onChange={this.handleInputChange}
	            />
	            </label>
	            <br />
	            <label>
	            <div className="text">Length of Activity (hours):</div> 
	            <input
	            	name="trip_time"
	            	type="number" min="0"
	            	value={this.state.tripTime}
	            	onChange={this.handleInputChange}
	            />
	            </label>
            </form>
		</li>
		);
	}
}
class LabActivity extends React.Component {
	constructor(props){
		super(props);
		const activityInfo = this.props.actInfo;
		const numLabsVal = (Object.prototype.hasOwnProperty.call(activityInfo, 'numLabs') ? activityInfo.numLabs : 0);
		const labTimeVal = (Object.prototype.hasOwnProperty.call(activityInfo, 'labTime') ? activityInfo.labTime : 0);
		const reportReqVal = (Object.prototype.hasOwnProperty.call(activityInfo, 'reportReq') ? activityInfo.reportReq : false);
		this.state = {
			visible: activityInfo.visible,
			category: activityInfo.category,
			type: activityInfo.type,
			actID: activityInfo.actID,
			eia: activityInfo.eia,
			ela: activityInfo.ela,
			numLabs: numLabsVal,
			labTime: labTimeVal,
			reportReq: reportReqVal
		};
		this.props.saveAct(this.state);
		this.handleInputChange = this.handleInputChange.bind(this);
		this.delete = this.delete.bind(this);
	}

	delete(){
		this.setState({
			visible: false
		});
		this.props.deleteAct(this.state.actID);
	}

	handleInputChange(event){
		const boxName = event.target.name;
		const value = event.target.name === 'report_req' ? event.target.checked : event.target.value;
		var numLabs = !(this.state.numLabs) ? 0 : parseFloat(this.state.numLabs);
		var labTime = !(this.state.labTime) ? 0 : parseFloat(this.state.labTime);
		var reportReq = this.state.reportReq;
		var currVal = 0;
		var newELA = 0;
		const updatedState = {};
		Object.assign(updatedState, this.state);

		switch(boxName) {
			case "lab_num":
				if(value !== ''){ currVal = parseFloat(value); }
				numLabs = currVal;
				this.setState({numLabs: value});
				updatedState.numLabs = value;
				break;
			case "lab_length":
				if(value !== ''){ currVal = parseFloat(value); }
				labTime = currVal;
				this.setState({labTime: value});
				updatedState.labTime = value;
				break;
			case "report_req":
				reportReq = value;
				break;
			default: break;
		}

		if(reportReq) { newELA = (numLabs*labTime) + (numLabs * .5); }
		else { newELA = numLabs * labTime;}
		this.setState({
			ela: newELA,
			reportReq: reportReq
		});

		updatedState.eia = this.state.eia;
		updatedState.ela = newELA;
		updatedState.reportReq = reportReq;
		this.props.calcTotals(updatedState, this.state.actID, this.state.category, this.state.eia, newELA);
	}

	render() {
		if(!this.state.visible) return null;
		return (
		<li key={this.state.actID} className="activity">
			<h3>{this.props.actInfo.name}</h3>
			<button className="delete" onClick={this.delete}>
				<svg aria-hidden="true" className="svg_delete" viewBox="0 0 20 20"><path></path></svg>
				Delete this activity
			</button>
            <p>{this.props.actInfo.description}</p>
			<form>
	            <label>
	            <div className="text">Number of Labs:</div>
	            <input
	            	name="lab_num"
	            	type="number" min="0"
	            	value={this.state.numLabs}
	            	onChange={this.handleInputChange}
	            />
	            </label>
	            <br />
	            <label>
	            <div className="text">Length of Lab (hours):</div> 
	            <input
	            	name="lab_length"
	            	type="number" min="0"
	            	value={this.state.labTime}
	            	onChange={this.handleInputChange}
	            />
	            </label>
	            <br />
	            <label>
	            <div className="checkbox">Report Required:</div>
	            <input
	            	name="report_req"
	            	type="checkbox"
	            	checked={this.state.reportReq}
	            	onChange={this.handleInputChange}
	            />
	            </label>
            </form>
		</li>
		);
	}
}
class GuidedProjectActivity extends React.Component {
	constructor(props){
		super(props);
		const activityInfo = this.props.actInfo;
		const numProjVal = (Object.prototype.hasOwnProperty.call(activityInfo, 'numProj') ? activityInfo.numProj : 0);
		const numWeeksVal = (Object.prototype.hasOwnProperty.call(activityInfo, 'numWeeks') ? activityInfo.numWeeks : 0);
		const sizeProjVal = (Object.prototype.hasOwnProperty.call(activityInfo, 'sizeProj') ? activityInfo.sizeProj : 'small');
		this.state = {
			visible: activityInfo.visible,
			category: activityInfo.category,
			type: activityInfo.type,
			actID: activityInfo.actID,
			eia: activityInfo.eia,
			ela: activityInfo.ela,
			numProj: numProjVal,
			numWeeks: numWeeksVal,
			sizeProj: sizeProjVal
		};
		this.props.saveAct(this.state);
		this.handleInputChange = this.handleInputChange.bind(this);
		this.delete = this.delete.bind(this);
	}

	delete(){
		this.setState({
			visible: false
		});
		this.props.deleteAct(this.state.actID);
	}

	handleInputChange(event){
		const boxName = event.target.name;
		const value = event.target.value;
		var numProj = !(this.state.numProj) ? 0 : parseFloat(this.state.numProj);
		var numWeeks = !(this.state.numWeeks) ? 0 : parseFloat(this.state.numWeeks);
		var sizeProj = this.state.sizeProj;
		var eiaScale = 1;
		var elaScale = 1;
		var newEIA = 0;
		var newELA = 0;
		const updatedState = {};
		Object.assign(updatedState, this.state);

	
		switch(boxName) {
			case "proj_num":
				if(value){numProj = parseFloat(value);}
				else {numProj = 0;}
				this.setState({numProj: value});
				updatedState.numProj = value;
				break;
			case "proj_weeks":
				if(value){numWeeks = parseFloat(value);}
				else {numWeeks = 0;}
				this.setState({numWeeks: value});
				updatedState.numWeeks = value;
				break;
			case "proj_size":
				sizeProj = value;
				this.setState({sizeProj: value});
				updatedState.sizeProj = value;
				break;
			default: break;
		}

		if(sizeProj === "small") {eiaScale = 1; elaScale = 1;}
		else if(sizeProj === "medium") {eiaScale = 2; elaScale = 5;}
		else if(sizeProj === "large") {eiaScale = 3; elaScale = 10;}
		newEIA = numProj * numWeeks * eiaScale;
		newELA = numProj * numWeeks * elaScale;
		this.setState({
			eia: newEIA,
			ela: newELA
		});

		updatedState.eia = newEIA;
		updatedState.ela = newELA;
		this.props.calcTotals(updatedState, this.state.actID, this.state.category, newEIA, newELA);
	}

	render() {
		if(!this.state.visible) return null;
		return (
		<li key={this.state.actID} className="activity">
			<h3>{this.props.actInfo.name}</h3>
			<button className="delete" onClick={this.delete}>
				<svg aria-hidden="true" className="svg_delete" viewBox="0 0 20 20"><path></path></svg>
				Delete this activity
			</button>
            <p>{this.props.actInfo.description}</p>
            <form>
	            <label>
	            <div className="text">Number of Projects:</div> 
	            <input
	            	name="proj_num"
	            	type="number" min="0"
	            	value={this.state.numProj}
	            	onChange={this.handleInputChange}
	            />
	            </label>
	            <br />
	            <label>
	            <div className="text">Number of Weeks Per Project:</div> 
	            <input
	            	name="proj_weeks"
	            	type="number" min="0"
	            	value={this.state.numWeeks}
	            	onChange={this.handleInputChange}
	            />
	            </label>
	            <br />
	            <label>
	            <div className="text">Size of Project:</div>
	            <select
	            	name="proj_size"
	            	value={this.state.group_size}
	            	onChange={this.handleInputChange} >
	            	<option value="small">Small</option>
	            	<option value="medium">Medium</option>
	            	<option value="large">Large</option>
	            </select>
	            </label>
            </form>
		</li>
		);
	}
}
class SourceInvestigationActivity extends React.Component {
	constructor(props){
		super(props);
		const activityInfo = this.props.actInfo;
		const numProjectsVal = (Object.prototype.hasOwnProperty.call(activityInfo, 'numProjects') ? activityInfo.numProjects : 0);
		const numPagesVal = (Object.prototype.hasOwnProperty.call(activityInfo, 'numPages') ? activityInfo.numPages : 0);
		this.state = {
			visible: activityInfo.visible,
			category: activityInfo.category,
			type: activityInfo.type,
			actID: activityInfo.actID,
			eia: activityInfo.eia,
			ela: activityInfo.ela,
			numProjects: numProjectsVal,
			numPages: numPagesVal,
		};
		this.props.saveAct(this.state);
		this.handleInputChange = this.handleInputChange.bind(this);
		this.delete = this.delete.bind(this);
	}

	delete(){
		this.setState({
			visible: false
		});
		this.props.deleteAct(this.state.actID);
	}

	handleInputChange(event){
		const boxName = event.target.name;
		const value = event.target.value;
		var numProjects = !(this.state.numProjects) ? 0 : parseFloat(this.state.numProjects);
		var numPages = !(this.state.numPages) ? 0 : parseFloat(this.state.numPages);
		var newEIA = 0;
		var newELA = 0;
		const updatedState = {};
		Object.assign(updatedState, this.state);
	
		switch(boxName) {
			case "project_num":
				if(value){numProjects = parseFloat(value);}
				else {numProjects = 0;}
				this.setState({numProjects: value});
				updatedState.numProjects = value;
				break;
			case "page_num":
				if(value){numPages = parseFloat(value);}
				else {numPages = 0;}
				this.setState({numPages: value});
				updatedState.numPages = value;
				break;
			default: break;
		}

		// Unclear how to set this
		newEIA = numProjects;
		newELA = (numPages * 2) * numProjects;
		this.setState({
			eia: newEIA,
			ela: newELA
		});

		updatedState.eia = newEIA;
		updatedState.ela = newELA;
		this.props.calcTotals(updatedState, this.state.actID, this.state.category, newEIA, newELA);
	}


	render() {
		if(!this.state.visible) return null;
		return (
		<li key={this.state.actID} className="activity">
			<h3>{this.props.actInfo.name}</h3>
			<button className="delete" onClick={this.delete}>
				<svg aria-hidden="true" className="svg_delete" viewBox="0 0 20 20"><path></path></svg>
				Delete this activity
			</button>
            <p>{this.props.actInfo.description}</p>
            <form>
	            <label>
	            <div className="text">Number of Investigations:</div> 
	            <input
	            	name="project_num"
	            	type="number" min="0"
	            	value={this.state.numProjects}
	            	onChange={this.handleInputChange}
	            />
	            </label>
	            <br />
	            <label>
	            <div className="text">Number of Pages per Investigation:</div> 
	            <input
	            	name="page_num"
	            	type="number" min="0"
	            	value={this.state.numPages}
	            	onChange={this.handleInputChange}
	            />
	            </label>
            </form>
		</li>
		);
	}
}

// Modules for Assessment Activites
class QuizActivity extends React.Component {
	constructor(props){
		super(props);
		const activityInfo = this.props.actInfo;
		const numQuizVal = (Object.prototype.hasOwnProperty.call(activityInfo, 'numQuiz') ? activityInfo.numQuiz : 0);
		const quizTimeVal = (Object.prototype.hasOwnProperty.call(activityInfo, 'quizTime') ? activityInfo.quizTime : 0);
		this.state = {
			visible: activityInfo.visible,
			category: activityInfo.category,
			type: activityInfo.type,
			actID: activityInfo.actID,
			eia: activityInfo.eia,
			ela: activityInfo.ela,
			numQuiz: numQuizVal,
			quizTime: quizTimeVal
		};
		this.props.saveAct(this.state);
		this.handleInputChange = this.handleInputChange.bind(this);
		this.delete = this.delete.bind(this);
	}

	delete(){
		this.setState({
			visible: false
		});
		this.props.deleteAct(this.state.actID);
	}

	handleInputChange(event){
		const boxName = event.target.name;
		const value = event.target.value;
		var numQuiz = !(this.state.numQuiz) ? 0 : parseFloat(this.state.numQuiz);
		var quizTime = !(this.state.quizTime) ? 0 : parseFloat(this.state.quizTime);
		var currVal = 0;
		var newEIA = 0;
		var newELA = 0;
		const updatedState = {};
		Object.assign(updatedState, this.state);

		if(value !== ''){ currVal = parseFloat(value); }
		switch(boxName) {
			case "quiz_num":
				numQuiz = currVal;
				this.setState({numQuiz: value});
				updatedState.numQuiz = value;
				break;
			case "quiz_time":
				quizTime = currVal;
				this.setState({quizTime: value});
				updatedState.quizTime = value;
				break;
			default: break;
		}

		newEIA = numQuiz * (quizTime/60);
		newELA = numQuiz * (quizTime/60);
		this.setState({
			eia: newEIA,
			ela: newELA
		});

		updatedState.eia = newEIA;
		updatedState.ela = newELA;
		this.props.calcTotals(updatedState, this.state.actID, this.state.category, newEIA, newELA);
	}

	render() {
		if(!this.state.visible) return null;
		return (
		<li key={this.state.actID} className="activity">
			<h3>{this.props.actInfo.name}</h3>
			<button className="delete" onClick={this.delete}>
				<svg aria-hidden="true" className="svg_delete" viewBox="0 0 20 20"><path></path></svg>
				Delete this activity
			</button>
            <p>{this.props.actInfo.description}</p>
            <form>
	            <label>
	            <div className="text">Number of Quizzes:</div>
	            <input
	            	name="quiz_num"
	            	type="number" min="0"
	            	value={this.state.numQuiz}
	            	onChange={this.handleInputChange}
	            />
	            </label>
	            <br />
	            <label>
	            <div className="text">Minutes Per Quiz:</div>
	            <input
	            	name="quiz_time"
	            	type="number" min="0"
	            	value={this.state.quizTime}
	            	onChange={this.handleInputChange}
	            />
	            </label>
            </form>
		</li>
		);
	}
}

// Modules for Other Activities
class CustomActivity extends React.Component {
	constructor(props){
		super(props);
		const activityInfo = this.props.actInfo;
		const numEIAVal = (Object.prototype.hasOwnProperty.call(activityInfo, 'numEIA') ? activityInfo.numEIA : 0);
		const numELAVal = (Object.prototype.hasOwnProperty.call(activityInfo, 'numELA') ? activityInfo.numELA : 0);
		this.state = {
			visible: activityInfo.visible,
			category: activityInfo.category,
			type: activityInfo.type,
			actID: activityInfo.actID,
			eia: activityInfo.eia,
			ela: activityInfo.ela,
			numEIA: numEIAVal,
			numELA: numELAVal
		};
		this.props.saveAct(this.state);
		this.handleInputChange = this.handleInputChange.bind(this);
		this.delete = this.delete.bind(this);
	}

	delete(){
		this.setState({
			visible: false
		});
		this.props.deleteAct(this.state.actID);
	}

	handleInputChange(event){
		const boxName = event.target.name;
		const value = event.target.value;
		var numEIA = !(this.state.numEIA) ? 0 : parseFloat(this.state.numEIA);
		var numELA = !(this.state.numELA) ? 0 : parseFloat(this.state.numELA);
		var currVal = 0;
		var newEIA = 0;
		var newELA = 0;
		const updatedState = {};
		Object.assign(updatedState, this.state);

		if(value !== ''){ currVal = parseFloat(value); }
		switch(boxName) {
			case "eia_num":
				numEIA = currVal;
				this.setState({numEIA: value});
				updatedState.numEIA = value;
				break;
			case "ela_num":
				numELA = currVal;
				this.setState({numELA: value});
				updatedState.numELA = value;
				break;
			default: break;
		}

		newEIA = numEIA;
		newELA = numELA;
		this.setState({
			eia: newEIA,
			ela: newELA
		});

		updatedState.eia = newEIA;
		updatedState.ela = newELA;
		this.props.calcTotals(updatedState, this.state.actID, this.state.category, newEIA, newELA);
	}

	render() {
		if(!this.state.visible) return null;
		return (
		<li key={this.state.actID} className="activity">
			<h3>{this.props.actInfo.name}</h3>
			<button className="delete" onClick={this.delete}>
				<svg aria-hidden="true" className="svg_delete" viewBox="0 0 20 20"><path></path></svg>
				Delete this activity
			</button>
            <p>{this.props.actInfo.description}</p>
            <form>
	            <label>
	            <div className="text">Instructional Time (hours):</div>
	            <input
	            	name="eia_num"
	            	type="number" min="0"
	            	value={this.state.numEIA}
	            	onChange={this.handleInputChange}
	            />
	            </label>
	            <br />
	            <label>
	            <div className="text">Student Learning Time (hours):</div>
	            <input
	            	name="ela_num"
	            	type="number" min="0"
	            	value={this.state.numELA}
	            	onChange={this.handleInputChange}
	            />
	            </label>
            </form>
         </li>
		);
	}
}


// controls the response alerts when an activity is added
function AlertTimer(){
	let alerts = document.getElementById('add_alert');
	let elements = alerts.getElementsByTagName('li');
	alerts.removeChild(elements[0]);
}

function AlertMessage(activity, category){
	// Add the alert
	let alertLocation = document.getElementById('add_alert');
	let alertMessage = activity + " added to " + category;
	let li = document.createElement("li");
	li.appendChild(document.createTextNode(alertMessage));
	alertLocation.appendChild(li);

	// set a timer, remove alert when done
	setTimeout(AlertTimer, 7000);

	return null;
}


/*************************************************************
* App Container
* The below section creates what you see in the app, filling
* each section accordingly, controlling the add and delete options
* and performing the needed math for the calculations. 
**************************************************************/

class AppContainer extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			// info about course length and credits
			courseInfo: defaultInfo.courseInfo,

			// calculated values
			eiaTotalHours: 0,
			elaTotalHours: 0,
			totalHours: 0,

			// info about categories
			categoryTypes: categoryDetails,

			// info about each activity is saved here
			activityInfo: defaultInfo.activityInfo,
			
			// default activities used when app is started
			// updated when activities are added or deleted
			displayedActivityInfo: defaultInfo.activityInfo
		}

		this.calcuateRecommendedTotals = this.calcuateRecommendedTotals.bind(this);
		this.importData = this.importData.bind(this);
		this.exportData = this.exportData.bind(this);
	}

	// Updates the totals after values are changed in the app.
	updateAppTotals = (currentActivityInfo, actID, catType, eiaHours, elaHours) => {
		// Update info for specific activity
		const activityArray = [];
		this.state.activityInfo.forEach(element => {
			let elementCopy = JSON.parse(JSON.stringify(element));
			activityArray.push(elementCopy);
		});
		var activityCurrent = activityArray.find(activity => (activity.actID === actID));
		Object.assign(activityCurrent, currentActivityInfo);
		this.setState(state => {
			return {
				activityInfo: activityArray,
			};
		});
		// recalculate the rest of the values
		this.recalculateTotalValues(activityArray);
	}

	// Calculate all totals for categories and overall
	recalculateTotalValues(activityArray){
		const actList = activityArray;
		const numActivities = activityArray.length;

		const catList = [];
		this.state.categoryTypes.forEach(element => {
			let elementCopy = JSON.parse(JSON.stringify(element));
			catList.push(elementCopy);
		});
		const numCategories = catList.length;

		// calculate the category totals
		for (let cat = 0; cat < numCategories; cat++){
			catList[cat].eia = 0;
			catList[cat].ela = 0;
			for (let act = 0; act < numActivities; act++){
				if(actList[act].category === catList[cat].category && actList[act].visible){
					catList[cat].eia += actList[act].eia;
					catList[cat].ela += actList[act].ela;
				}
			}
			catList[cat].total = catList[cat].eia + catList[cat].ela;
		}
		
		// calculate the overall totals
		var newEIA = 0;
		var newELA = 0;
		var newTotal = 0;
		for (let cat = 0; cat < numCategories; cat++) {
			newEIA = newEIA + catList[cat].eia;
			newELA = newELA + catList[cat].ela;
		}
		newTotal = newEIA + newELA;
		this.setState({
			categoryTypes: catList,
			eiaTotalHours: newEIA,
			elaTotalHours: newELA,
			totalHours: newTotal
		});
	}

	getActivity(categoryType, currentActivityInfo) {
		// if actID is 0, assign a unique actID to it
		if (currentActivityInfo.actID === 0) {currentActivityInfo.actID = actIDCount++;}

		// get the information for this activity
		//var categoryCurrent = categoryArray.find(category => (category.category === currentActivity.category));
		const activityType = currentActivityInfo.type;
		const categoryInfo = activityDetails.find(category => (category.category === categoryType)).activities;
		currentActivityInfo.name = categoryInfo.find(activity => (activity.type === currentActivityInfo.type)).name;
		currentActivityInfo.description = categoryInfo.find(activity => (activity.type === currentActivityInfo.type)).description;

		// Holds the activity calls to create each activity box when one is added
		const actCalls = {
			writing: {
				discussion: <DiscussionActivity actInfo={currentActivityInfo} calcTotals={this.updateAppTotals} saveAct={this.saveNewActivity} deleteAct={this.deleteActivity} />,
				reflectionPaper: <ReflectionPaperActivity actInfo={currentActivityInfo} calcTotals={this.updateAppTotals} saveAct={this.saveNewActivity} deleteAct={this.deleteActivity}  />,
				researchPaper: <ResearchPaperActivity actInfo={currentActivityInfo} calcTotals={this.updateAppTotals} saveAct={this.saveNewActivity} deleteAct={this.deleteActivity} />,
				peerReview: <PeerReviewActivity actInfo={currentActivityInfo} calcTotals={this.updateAppTotals} saveAct={this.saveNewActivity} deleteAct={this.deleteActivity}  />,
				blog: <BlogActivity actInfo={currentActivityInfo} calcTotals={this.updateAppTotals} saveAct={this.saveNewActivity} deleteAct={this.deleteActivity} />,
				journal: <JournalActivity actInfo={currentActivityInfo} calcTotals={this.updateAppTotals} saveAct={this.saveNewActivity} deleteAct={this.deleteActivity}  />,
				caseStudies: <CaseStudiesActivity actInfo={currentActivityInfo} calcTotals={this.updateAppTotals} saveAct={this.saveNewActivity} deleteAct={this.deleteActivity}  />,
				postingUpdates: <PostingUpdatesActivity actInfo={currentActivityInfo} calcTotals={this.updateAppTotals} saveAct={this.saveNewActivity} deleteAct={this.deleteActivity}  />,
				custom: <CustomActivity actInfo={currentActivityInfo} calcTotals={this.updateAppTotals} saveAct={this.saveNewActivity} deleteAct={this.deleteActivity} />
			},
			reading: {
				lecture: <LectureActivity actInfo={currentActivityInfo} calcTotals={this.updateAppTotals} saveAct={this.saveNewActivity} deleteAct={this.deleteActivity}  />,
				assignedReading: <AssignedReadingActivity actInfo={currentActivityInfo} calcTotals={this.updateAppTotals} saveAct={this.saveNewActivity} deleteAct={this.deleteActivity} />,
				scholarlyReading: <ScholarlyReadingActivity actInfo={currentActivityInfo} calcTotals={this.updateAppTotals} saveAct={this.saveNewActivity} deleteAct={this.deleteActivity} />,
				instructionalContent: <InstructionalContentActivity actInfo={currentActivityInfo} calcTotals={this.updateAppTotals} saveAct={this.saveNewActivity} deleteAct={this.deleteActivity} />,
				problemSolving: <ProblemSolvingActivity actInfo={currentActivityInfo} calcTotals={this.updateAppTotals} saveAct={this.saveNewActivity} deleteAct={this.deleteActivity}  />
			},
			communication: {
				syncCommunication: <SyncCommunicationActivity actInfo={currentActivityInfo} calcTotals={this.updateAppTotals} saveAct={this.saveNewActivity} deleteAct={this.deleteActivity} />
			},
			project: {
				groupProject: <GroupProjectActivity actInfo={currentActivityInfo} calcTotals={this.updateAppTotals} saveAct={this.saveNewActivity} deleteAct={this.deleteActivity} />,
				video: <VideoActivity actInfo={currentActivityInfo} calcTotals={this.updateAppTotals} saveAct={this.saveNewActivity} deleteAct={this.deleteActivity} />,
				podcast: <PodcastActivity actInfo={currentActivityInfo} calcTotals={this.updateAppTotals} saveAct={this.saveNewActivity} deleteAct={this.deleteActivity} />,
				mediaAlbum: <MediaAlbumActivity actInfo={currentActivityInfo} calcTotals={this.updateAppTotals} saveAct={this.saveNewActivity} deleteAct={this.deleteActivity} />,
				trip: <TripActivity actInfo={currentActivityInfo} calcTotals={this.updateAppTotals} saveAct={this.saveNewActivity} deleteAct={this.deleteActivity} />,
				lab: <LabActivity actInfo={currentActivityInfo} calcTotals={this.updateAppTotals} saveAct={this.saveNewActivity} deleteAct={this.deleteActivity} />,
				guidedProject: <GuidedProjectActivity actInfo={currentActivityInfo} calcTotals={this.updateAppTotals} saveAct={this.saveNewActivity} deleteAct={this.deleteActivity} />,
				sourceInvestigation: <SourceInvestigationActivity actInfo={currentActivityInfo} calcTotals={this.updateAppTotals} saveAct={this.saveNewActivity} deleteAct={this.deleteActivity} />
			},
			assessment: {
				quiz: <QuizActivity actInfo={currentActivityInfo} calcTotals={this.updateAppTotals} saveAct={this.saveNewActivity} deleteAct={this.deleteActivity} />
			},
			other: {
				custom: <CustomActivity actInfo={currentActivityInfo} calcTotals={this.updateAppTotals} saveAct={this.saveNewActivity} deleteAct={this.deleteActivity} />
			}
		};

		// Return the activity to be rendered
		return actCalls[categoryType][activityType];
	}

	renderCategory(category) {
		// information about the current category
		const actList = []; 
		const catName = this.state.categoryTypes.filter(cat => (cat.category === category))[0].name;
		// get the activities to display
		var currentActivities = [];
		for(let i = 0; i < this.state.displayedActivityInfo.length; i++){
			if(this.state.displayedActivityInfo[i].category === category) currentActivities.push(this.state.displayedActivityInfo[i]);
		}	
		for(let i = 0; i < currentActivities.length; i++) {
			actList.push(this.getActivity(category, currentActivities[i]));
		}

		// displays the category and its activities
		return <React.Fragment>
				<h2 className="category_header"><button aria-expanded="false">
					<div className="category-title">{catName}</div>
					<div className="category-expandbutton">
					<svg viewBox="0 0 10 10" width="20" height="20" aria-hidden="true" focusable="false">
    					<rect className="vert" height="8px" width="2px" y="1" x="4" />
    					<rect height="2" width="8" y="4" x="1" />
  					</svg>
  					</div>
					</button> 
				</h2>
				<div className="collapse_container" display="none" hidden>
					<div className="activity_set">
						{actList}
					</div>
				</div>
				</React.Fragment>;
	}

	// Saves a new activity into the activityInfo 
	saveNewActivity = (actInfo) => {
		// if activity is not found, either it is imported or new
		const found = this.state.activityInfo.includes(actInfo);
		if(!found){
			// if new , actID === 0
			if(actInfo.actID === 0){
				actInfo.actID = actIDCount++;
				this.setState(state => {
					const activityInfo = state.activityInfo.concat(actInfo)
					return {
						activityInfo,
					};
				});
				
			}
			// if imported, actID != 0
			else{
				const activityArray = [];
				this.state.activityInfo.forEach(element => {
					let elementCopy = JSON.parse(JSON.stringify(element));
					activityArray.push(elementCopy);
				});
				let oldActInfo = activityArray.find(act => (act.actID === actInfo.actID));
				const index = activityArray.indexOf(oldActInfo);
				if(index > -1){
					oldActInfo = actInfo;
					this.setState(state => {
					return {
						activityInfo: activityArray
					};
				});
				}
			}
		}
	} 

	// Add a new instance of this type of activity when button clicked
	addNewActivity(catInfo, actInfo){
		const newActivity = {category: catInfo.category, type: actInfo.type, actID: 0, eia: 0, ela: 0, visible: true};
		const newActivityArray = this.state.activityInfo.concat(newActivity);
		const catName = this.state.categoryTypes.find(object => object.category === catInfo.category).name;
		this.setState({
			activityInfo: newActivityArray,
			displayedActivityInfo: newActivityArray
		});
		AlertMessage(actInfo.name, catName);
	}

	// Delete a specific activity instance (box)
	deleteActivity = (actID) => {
		// get full information about current activity
		const newActivityArray = this.state.activityInfo.slice();
		let currentActivity = this.state.activityInfo.find(object => object.actID === actID);

		// if activity exists, delete it
		const index = this.state.activityInfo.indexOf(currentActivity);
		if (index > -1) {
			// set visible to false
			currentActivity.visible = false;
			this.setState({
				activityInfo: newActivityArray,
				//displayedActivityInfo: newActivityArray
			});
			this.recalculateTotalValues(newActivityArray);
		}
	}

	// Calculate the recommended totals based on course details
	calcuateRecommendedTotals(event){
		// recommended hours
		const eiaPerCredit = 15;
		const elaPerCredit = 30;
		const totalPerCredit = 45;
		// app calculated values
		const boxName = event.target.name;
		const value = event.target.value;
		let eiaHours = 0;
		let elaHours = 0;
		let totalHours = 0;
		let eiaWeekly = 0;
		let elaWeekly = 0;
		const numCredits = this.state.courseInfo.courseCredits;
		const numWeeks = this.state.courseInfo.courseLength;
		let currVal = 0;
		let newCredits = 0;
		let newWeeks = 0;
		let lenVal = 0;
		let credVal = 0;

		if(value !== ''){currVal = parseFloat(value);}
		switch(boxName) {
			case "course_length":
				newWeeks = currVal;
				newCredits = numCredits;
				lenVal = value;
				credVal = numCredits;
				break;
			case "course_credits":
				newCredits = currVal;
				newWeeks = numWeeks;
				lenVal = numWeeks;
				credVal = value;
				break;
			default: break;
		}

		eiaHours = newCredits * eiaPerCredit;
		elaHours = newCredits * elaPerCredit;
		totalHours = newCredits * totalPerCredit;
		eiaWeekly = (newWeeks === 0) ? eiaHours : eiaHours / newWeeks;
		elaWeekly = (newWeeks === 0) ? elaHours : elaHours / newWeeks;

		this.setState({
			courseInfo: {
				lengthValue: lenVal,
				creditsValue: credVal,
				courseLength: newWeeks,
				courseCredits: newCredits,
				eiaRecommended: eiaHours,
				elaRecommended: elaHours,
				totalRecommended: totalHours,
				eiaWeekly: eiaWeekly,
				elaWeekly: elaWeekly
			}
		});
	}

	// Save data  to a file
	exportData(){
		let testJson = {
 			courseInfo: this.state.courseInfo,
			activityInfo: this.state.activityInfo
 		};
 		const blobject = new Blob([JSON.stringify(testJson)], {type: 'application/json'});
 		const blobUrl = URL.createObjectURL(blobject);

 		// get data information for file name
 		var currDate = new Date();
 		let dateString = "HIA-Data_" + currDate.getFullYear() + "-" + currDate.getMonth() + "-" + currDate.getDate() + ".txt";

		// download information
 		const downloadLink = document.createElement('a');
		downloadLink.href = blobUrl;
		downloadLink.setAttribute('href', blobUrl);
		downloadLink.setAttribute('download', dateString);
		downloadLink.style.display = 'none';
		document.body.appendChild(downloadLink);
		downloadLink.click();
		document.body.removeChild(downloadLink);
	}

	// Take data from file, restart app with it
	importData(){
		const fileSelector = document.getElementById('importFileSelector');
  		fileSelector.addEventListener('change', function fileListener(event) {
    		const file = event.target.files[0]; 
			const reader = new FileReader();
          	reader.readAsText(file);
          	reader.addEventListener("load", (event) => {
          		let validFile = false;
          		const fileContents = event.target.result;
          		var jsonBlob;
          		// file has been translated to text in reader object
          		try {
	          		jsonBlob = JSON.parse(fileContents);
	          		if(!jsonBlob.courseInfo || !jsonBlob.activityInfo) {
	          			console.log("Invalid file format.");
	          		}
	          		else{
	          			validFile = true;
	          		}
          		} catch (e) {
          			validFile = false;
          		}
          		if(validFile){
	          		const newData = {
	 					courseInfo: jsonBlob.courseInfo,
						activityInfo: jsonBlob.activityInfo
	 				};
					refreshApp(newData);
				}
				else{
					console.log("ERROR: Invalid file.");
					const content = document.getElementById('root');
					const errorMsg = document.createElement('div');
					errorMsg.innerHTML = "<p>Error:</br>Invalid file. Please only import unedited original export files from this app.</p>" +
										 "<button id='errorButton'>OK</button>";
					errorMsg.id = 'error';
					content.appendChild(errorMsg);
					document.getElementById('errorButton').addEventListener("click", () => {content.removeChild(errorMsg);});
				}
			}, false);

          	
  		});
	}

	// Remove all activities - not used right now
	deleteAll(){
		const newActivityArray = this.state.activityInfo.slice();
		for(let i = 0; i < newActivityArray.length; i++){
			newActivityArray[i].visible = false;
		}
		const newData = {
 			courseInfo: this.state.courseInfo,
			activityInfo: newActivityArray
 		};
		refreshApp(newData);
	}

	// Display result calculations based on "Weekly" or "Semester" view
	toggleResults(viewMode){
		const semesterViewBox = document.getElementById('semester_viewbox');
		const weekViewBox = document.getElementById('week_viewbox');
		const semesterButton = document.getElementById('semester_button');
		const weekButton = document.getElementById('week_button');
		if(viewMode === 1){
			console.log("Semester Selected");
			weekViewBox.classList.add('hidden');
			weekViewBox.classList.remove('visible');
			semesterViewBox.classList.remove('hidden');
			semesterViewBox.classList.add('visible');
			semesterButton.classList.add('selected');
			weekButton.classList.remove('selected');
		}
		else {
			console.log("Week Selected");
			weekViewBox.classList.remove('hidden');
			weekViewBox.classList.add('visible');
			semesterViewBox.classList.add('hidden');
			semesterViewBox.classList.remove('visible');
			semesterButton.classList.remove('selected');
			weekButton.classList.add('selected');
		}
	}



	render() {
		return (
			<React.Fragment>
			{/* Displays the activities in their categories */}
				<div className="activity_container">
				{this.state.categoryTypes.map((item) => (
					<div className="category_container">{this.renderCategory(item.category)}</div>	
				))}
				</div>

			{/* Displays the results and list of activities that can be added */}
				<div className="result_container">
				<div className="more_options">
					<div className="course_details">
					<h2 className="result_header">Course Details</h2>
						<form>
				            <label>
				            <span className="text">Course Length (Weeks): </span>
				            <input
				            	name="course_length"
				            	type="number" min="0"
				            	value={this.state.courseInfo.lengthValue}
				            	onChange={this.calcuateRecommendedTotals}
				            />
				            </label>
				            <br />
				            <label>
				            <span className="text">Number of Credits: </span>
				            <input
				            	name="course_credits"
				            	type="number" min="0"
				            	value={this.state.courseInfo.creditsValue}
				            	onChange={this.calcuateRecommendedTotals}
				            />
				            </label>
				        </form>
					</div>
					<div className="add_activities">
					<h2 className="category_header"><button aria-expanded="false">
						<div className="category-title">Add More Activities</div>
						<div className="category-expandbutton">
						<svg viewBox="0 0 12 12" width="12" height="12" aria-hidden="true" focusable="false">
	    					<rect className="vert" height="12" width="2" y="0" x="5" />
	    					<rect height="2" width="12" y="5" x="0" />
	  					</svg>
	  					</div>
						</button> 
					</h2>
					<div display="none" hidden>
					<p>
						{activityDetails.map((cat) => (
							<span>  
							{cat.activities.map((act) => (
								<button className="add_button" onClick={() => this.addNewActivity(cat, act)}>+ {act.name}</button>	
							))}
							</span>
						))}
					</p>
					<ul id="add_alert"></ul>
					</div>
					</div>
				</div>
				<div className="result_sticky">
				<div className="estimations_container">
					<div className="chart">
							<h2 className="result_header">Estimated Time</h2>
							<p>Based on a {this.state.courseInfo.courseLength}-week, {this.state.courseInfo.courseCredits}-credit course.</p>
							<canvas id="chart_container"></canvas>
							<p className="tip">Tip: Click a category title above to hide it in the chart.</p>
					</div>
					<div className="viewbox_container">	
						<div className="view_tab">
							<button id="semester_button" className="selected" onClick={() => this.toggleResults(1)}>Semester View</button>
							<button id="week_button" onClick={() => this.toggleResults(2)}>Week View</button>
						</div>
						<div id="semester_viewbox" display="block">
							<div className="result_calculations">
							<p>The following estimates are based on the activities for the entire length of the course, 
								with recommended hours based on course credits and length.</p>
								<h3>Equivalent Instructional Activities (EIA):</h3>
								<p>
								<span className="bold">
									Estimated Hours: </span> 
									{Number.parseFloat(this.state.eiaTotalHours).toFixed(2)} hrs
			            ({Number.parseFloat(this.state.eiaTotalHours/this.state.courseInfo.lengthValue).toFixed(2)} per week)
									<br/>
								<span className="bold">
									Recommended: </span> 
									{Number.parseFloat(this.state.courseInfo.eiaRecommended).toFixed(0)} hrs 
									({Number.parseFloat(this.state.courseInfo.eiaWeekly).toFixed(2)} per week)
								</p>
								<h3>Equivalent Learning Activities (ELA):</h3>
								<p>
								<span className="bold">
									Estimated Hours: </span> 
									{Number.parseFloat(this.state.elaTotalHours).toFixed(2)} hrs 
			            ({Number.parseFloat(this.state.elaTotalHours/this.state.courseInfo.lengthValue).toFixed(2)} per week)
									<br/>
								<span className="bold">
									Recommended: </span> 
									{Number.parseFloat(this.state.courseInfo.elaRecommended).toFixed(0)} hrs ({Number.parseFloat(this.state.courseInfo.elaWeekly).toFixed(2)} per week)
								</p>
								<h3>Total Hours of Instructional Activity:</h3>
								<p>
								<span className="bold">
									Estimated Hours: </span> 
									{Number.parseFloat(this.state.totalHours).toFixed(2)} hrs 
									<br/>
								<span className="bold">
									Recommended: </span> 
									{Number.parseFloat(this.state.courseInfo.totalRecommended).toFixed(0)} hrs
								</p>
							</div>
						</div>
						<div id="week_viewbox" display="block" class="hidden">
							<div className="result_calculations">
								<p>The following estimates are based on a single week of activities, 
								with recommended hours based on course credits and length.</p>
								<h3>Equivalent Instructional Activities (EIA):</h3>
								<p>
								<span className="bold">
									Estimated Hours: </span> 
									{Number.parseFloat(this.state.eiaTotalHours).toFixed(2)} hrs
									<br/>
								<span className="bold">
									Recommended: </span>  
									{Number.parseFloat(this.state.courseInfo.eiaWeekly).toFixed(2)} hrs per week
								</p>
								<h3>Equivalent Learning Activities (ELA):</h3>
								<p>
								<span className="bold">
									Estimated Hours: </span> 
									{Number.parseFloat(this.state.elaTotalHours).toFixed(2)} hrs 
			            			<br/>
								<span className="bold">
									Recommended: </span> 
									{Number.parseFloat(this.state.courseInfo.elaWeekly).toFixed(2)} hrs per week
								</p>
								<h3>Total Hours of Instructional Activity:</h3>
								<p>
								<span className="bold">
									Estimated Hours: </span> 
									{Number.parseFloat(this.state.totalHours).toFixed(2)} hrs 
									<br/>
								<span className="bold">
									Recommended: </span> 
									{Number.parseFloat(this.state.courseInfo.totalRecommended).toFixed(0)/this.state.courseInfo.lengthValue} hrs per week
								</p>
							</div>
						</div>
					</div>
				</div>
				<div className="buttons">
				<h2>Save and Share</h2>
				<button className="download pdf_button" onClick={() => {window.print();}}>Download PDF or Print</button>
				<label id="importLabel" htmlFor="importFileSelector">
					<svg id="import_svg" viewBox="0 0 20 20"><path></path></svg>
					<span>Import Data</span>
				</label>
				<input type="file" accept=".txt" id="importFileSelector" />
				<button className="download export_button" onClick={this.exportData}>
					<svg id="export_svg" viewBox="0 0 20 20"><path></path></svg>
					<span>Export Data</span>
				</button>
				<p><span className="bold">Save:</span> Click the "Export Data" button to download a copy of the app data. <br/>
				   <span className="bold">Share:</span>  Share the exported file with others. <br />
				   <span className="bold">Restore Saved Data:</span>  Click the "Import Data" button to upload your exported data file.
				</p>
				</div>
				</div>
				</div>
			</React.Fragment>
		);
	}

	// things to do once app has loaded (or reloaded)
	componentDidMount() {
		displayChart(this.state.categoryTypes);
		collapseCategories();
		this.recalculateTotalValues(defaultInfo.activityInfo);

		// initialize button listener for import file
		this.importData();

		// prevent negative numbers from being entered into fields
		var numbers = document.querySelectorAll("input[type=number]");
		// Listen for input event on numInput.
		Array.prototype.forEach.call(numbers, num => {
			num.onkeypress = function(e) {
	    		if(!((e.keyCode > 95 && e.keyCode < 106)
	      			|| (e.keyCode > 47 && e.keyCode < 58) 
	      			|| e.keyCode === 8 
	      			|| e.keyCode === 9
              || e.keyCode === 46
              || e.keyCode === 110
              || e.keyCode === 190
	      			|| (e.keyCode > 36 && e.keyCode < 41))) {
	        		return false;
	    		}
			}
		});
	}

	componentDidUpdate(){
		displayChart(this.state.categoryTypes);
	}

	componentWillUnmount(){
	}

}


/*************************************************************
* App Information
* The below variables hold the information in the app.
**************************************************************/

var myChart;
var actIDCount = 1;

// defaultInfo: Holds what the app displays when it first launches.
// Adding or removing a line in activityInfo will add/remove that
// activity from the default view.
var defaultInfo = {
	courseInfo: {
		lengthValue: 15,
		creditsValue: 3,
		courseLength: 15,
		courseCredits: 3,
		eiaRecommended: 45,
		elaRecommended: 90,
		totalRecommended: 135,
		eiaWeekly: 3,
		elaWeekly: 6
	},
	activityInfo: [
		{category: "writing", type: "discussion", actID: 0, eia: 0, ela: 0, visible:true},
		{category: "writing", type: "reflectionPaper", actID: 0, eia: 0, ela: 0, visible:true},
		{category: "writing", type: "researchPaper", actID: 0, eia: 0, ela: 0, visible:true},
		{category: "writing", type: "peerReview", actID: 0, eia: 0, ela: 0, visible:true},
		{category: "writing", type: "blog", actID: 0, eia: 0, ela: 0, visible:true},
		{category: "writing", type: "journal", actID: 0, eia: 0, ela: 0, visible:true},
		{category: "writing", type: "caseStudies", actID: 0, eia: 0, ela: 0, visible:true},
		{category: "writing", type: "postingUpdates", actID: 0, eia: 0, ela: 0, visible:true},
		{category: "reading", type: "assignedReading", actID: 0, eia: 0, ela: 0, visible:true},
		{category: "reading", type: "scholarlyReading", actID: 0, eia: 0, ela: 0, visible:true},
		{category: "reading", type: "problemSolving", actID: 0, eia: 0, ela: 0, visible:true},
		{category: "reading", type: "lecture", actID: 0, eia: 0, ela: 0, visible:true},
		{category: "reading", type: "instructionalContent", actID: 0, eia: 0, ela: 0, visible:true},
		{category: "communication", type: "syncCommunication", actID: 0, eia: 0, ela: 0, visible:true},
		{category: "project", type: "groupProject", actID: 0, eia: 0, ela: 0, visible:true},
		{category: "project", type: "video", actID: 0, eia: 0, ela: 0, visible:true},
		{category: "project", type: "podcast", actID: 0, eia: 0, ela: 0, visible:true},
		{category: "project", type: "mediaAlbum", actID: 0, eia: 0, ela: 0, visible:true},
		{category: "project", type: "trip", actID: 0, eia: 0, ela: 0, visible:true},
		{category: "project", type: "lab", actID: 0, eia: 0, ela: 0, visible:true},
		{category: "project", type: "guidedProject", actID: 0, eia: 0, ela: 0, visible:true},
		{category: "project", type: "sourceInvestigation", actID: 0, eia: 0, ela: 0, visible:true},
		{category: "assessment", type: "quiz", actID: 0, eia: 0, ela: 0, visible:true},
		{category: "other", type: "custom", actID: 0, eia: 0, ela: 0, visible:true}
	]
};

// categoryDetails: Holds the information about each category.
const categoryDetails = [
	{catID: 0, category: "writing", name: "Writing", eia: 0, ela: 0, total: 0},
	{catID: 1, category: "reading", name: "Reading & Watching", eia: 0, ela: 0, total: 0},
	{catID: 2, category: "communication", name: "Communication", eia: 0, ela: 0, total: 0}, 
	{catID: 3, category: "project", name: "Projects & Hands-On Learning", eia: 0, ela: 0, total: 0}, 
	{catID: 4, category: "assessment", name: "Assessment", eia: 0, ela: 0, total: 0},
	{catID: 5, category: "other", name: "Other", eia: 0, ela: 0, total: 0}
];

// activityDetails: Holds the information about each activity type.
const activityDetails = [
	{category: "writing", catName: "Writing", activities:
		[
			{type: "discussion", 
				name:"Discussion Activities", 
				description: "Clearly defined and guided discussion directly related to course objectives."
			},
			{type: "reflectionPaper", 
				name:"Reflection Paper", 
				description: "Informal writing in reaction to a reading, video, quote, or questions from professor."
			},
			{type: "researchPaper", 
				name:"Research Paper", 
				description: "Research and writing of a formal research paper."
			},
			{type: "peerReview", 
				name:" Peer Review or Assessment", 
				description: "Review of peer papers."
			},
			{type: "blog", 
				name:"Blog Entries", 
				description: "Writing activities for applying learning concepts and reflecting on learning experiences, shared with the instructor and students."
			},
			{type: "journal", 
				name:"Journal Entries", 
				description: "Writing activities for applying learning concepts and reflecting on learning experiences, shared only with the instructor."
			},
			{type: "caseStudies", 
				name:"Case Study & Analysis", 
				description: "In-depth analysis related to course objectives and shared with instructor and/or classmates."
			},
			{type: "postingUpdates", 
				name:"Posting Updates", 
				description: "Required posting of updates to class, may involve some research and minimal writing."
			}
		]
	},
	{category:"reading", catName: "Reading & Watching", activities:
		[
			{type: "assignedReading", 
				name:"Assigned Readings", 
				description: "Assigned readings from sources such as online content, popular reading, and websites."
			},
			{type: "scholarlyReading", 
				name:"Scholarly Readings", 
				description: "Assigned scholarly readings from sources such as textbooks and scholarly papers."
			},
			{type: "problemSolving", 
				name:"Problem Solving Scenarios", 
				description: "In-depth analysis related to course objectives that may or may not be shared with instructor and/or classmates."
			},
			{type: "lecture", 
				name:"Lecture Activities with Note-Taking", 
				description: "Written notes in response to video and lecture content."
			},
			{type: "instructionalContent", 
				name:"Instructional Content", 
				description: "Instructor-mediated PowerPoints, videos, and other content to expand upon and clarify course objectives and concepts."
			}
		]
	},
	{category: "communication", catName: "Communication", activities:
		[
			{type: "syncCommunication", 
				name:"Synchronous Communication", 	
				description: "Examples: conference calls, chat, phone call, video conference, web conference."
			}
		]
	},
	{category: "project", catName: "Projects & Hands-On Learning", activities:
		[
			{type: "groupProject", 
				name:"Group Projects", 
				description: "Brainstorming as a group, researching, sharing files, collaborating on creating project."
			},
			{type: "video", 
				name:"Media Project: Video", 
				description: "Video projects including interviews, informal recordings, field productions, and animations."
			},
			{type: "podcast", 
				name:"Media Project: Podcast", 
				description: "Podcast projects including interviews, informal recordings, field recordings, and creative projects."
			},
			{type: "mediaAlbum", 
				name:"Media Albums", 
				description: "Research and upload media from the internet or respond to instructor selected content that enhances class learning on a specific concept or concepts."
			},
			{type: "trip", 
				name:"Tours & Field Trips", 
				description: "Activities, including virtual, that can be analyzed and learned from in relation to course content."
			},
			{type: "lab", 
				name:"Laboratory Activities & Reports", 
				description: "Creating and conducting experiments and writing lab reports."
			},
			{type: "guidedProject", 
				name:"Guided or Service Learning Project", 
				description: "Projects that include guidance and collaborative work depending on specific objectives and deliverables."
			},
			{type: "sourceInvestigation", 
				name:"Primary Source Investigation", 
				description: "Instructor-guided reading and analysis of primary sources. Tied to specific course outcomes, instructor feedback provided."
			}
		]
	},
	{category: "assessment", catName: "Assessment", activities:
		[
			{type: "quiz", 
				name:"Online Quizzes & Tests", 
				description: "Opportunity for instructor to assess students’ subject knowledge and provide feedback on students’ progress."
			},
		]
	},
	{category: "other", catName: "Other", activities:
		[
			{type: "custom", 
				name:"Custom Activity", 
				description: "A custom activity that does not fit the other activity descriptions. Enter the number of expected hours of instructional work and student work to add to the totals."
			}
		]
	}
]; 

/*************************************************************
* Special Functions
* Controls how the app behaves in general, such as how the
* chart is displayed, how the app is refreshed when given an
* import file, and how sections collage/expand.
**************************************************************/

function refreshApp(activityInfo){
	defaultInfo = activityInfo;
	myChart = null;
	ReactDOM.unmountComponentAtNode(document.getElementById('generated_content'));
	ReactDOM.render(
  		<AppContainer />,
		document.getElementById('generated_content'),
	);
}

function collapseCategories() {
  const headings = document.querySelectorAll('h2.category_header');
  
  Array.prototype.forEach.call(headings, h => {
    let btn = h.querySelector('button');
    let target = h.nextElementSibling;
    
    btn.onclick = () => {
     let expanded = btn.getAttribute('aria-expanded') === 'true';
      
     btn.setAttribute('aria-expanded', !expanded);
     target.hidden = expanded;
    }
  });
}

function displayChart(chartData){
	var categoryLabels = [];
	for(let i = 0; i < chartData.length; i++){
		categoryLabels.push(chartData[i].name);
	}
	var totalHours = [];
	var isEmpty = true;
	for(let i = 0; i < chartData.length; i++){
		if(chartData[i].total > 0) {isEmpty = false;}
		totalHours.push(chartData[i].total);
	}
	var ctx = document.getElementById('chart_container').getContext('2d');
	if(myChart) {
		myChart.data.labels = categoryLabels;
		if(isEmpty) {
			myChart.data.datasets[0].data = [0, 0, 0, 0, 0, 0, 1];
			myChart.options.tooltips.enabled = false;
		}
		else {
			myChart.data.datasets[0].data = totalHours;
			myChart.options.tooltips.enabled = true;
		}
		myChart.update();
	}
	else {
		myChart = new Chart(ctx, {
	    // The type of chart we want to create
	    type: 'pie',

	    // The data for our dataset
	    data: {
	        labels: categoryLabels,
	        datasets: [{
	            label: 'EIA Estimates',
	            backgroundColor: [
	    		'#B88965',
	    		'#96BEE6',
	    		'#AC8DCE',
	    		'#91959C',
	    		'#1E407C',
	    		'#3EA39E',
	    	],
	            borderColor: 'rgb(255, 255, 255)',
	            data: [0, 0, 0, 0, 0, 0, 1],
	        }]
	    },

	    // Configuration options go here
	    options: {
	    	responsive: true,
	    	aspectRatio: .75,
	    	animation: {
	    		animateRotate: false,
	    		animateScale: false,
	    	},
	    	legend: {
	    		position: 'bottom',
	    		align: 'start',
	    		display: true,
	    		labels: {
	    			fontColor: 'black',
	    			fontSize: 12,
	    		},
	    		// onHover: function(event, legendItem) {
	    			
	    		// }
	    	},
	    	tooltips: {
	    		enabled: false,
	    	}
	    }
		});
	}
}

if ( window.location !== window.parent.location ) {	  
	// The page is in an iframe	
	console.log("This is in an iframe.");
	var style = document.createElement('style');
  	style.innerHTML = `
  		#container{
  			padding: 0;
  		}
  		#external_hia_app_information, #hia-app-footer{
  			display: none;}
  		`;
  	document.head.appendChild(style);

} else {	  
	// The page is not in an iframe, so do nothing special right now
}

// Puts the app on the page
ReactDOM.render(
  <AppContainer />,
	document.getElementById('generated_content'),
);


